import React from "react";
import CardFooter from "components/Card/CardFooter.jsx";
import CryptoJS from "crypto-js";
import CardHeader from "components/Card/CardHeader.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
// import Tabs from "@material-ui/core/Tabs";
// import Tab from "@material-ui/core/Tab";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Slide from "@material-ui/core/Slide";
import $ from "jquery";
import Result from "./CustomQueryBuilder/Result";
import CResult from "./CCustomQueryBuilder/Result";
import API from "@aws-amplify/api";
import buttonsStyle from "assets/jss/material-dashboard-pro-react/views/buttonsStyle.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ViewAudiences from "./ViewAudiences";
import Summary from "./Summary.jsx";
//import "assets/scss/styles.css";
import "assets/scss/responsive.css";
import Modal from "react-responsive-modal";
import anistyles from "./custom-animation.css";
import pencil from "assets/img/pencil.svg";
import close from "assets/img/close.svg";
import Segment from "./Segment";
import DonutChart from "./DonutChart";
import GroupModal from "./CustomQueryBuilder/Modal";
import CGroupModal from "./CCustomQueryBuilder/Modal";
import CustomerFilter from "./CustomerFilter";
import "./customstyle.css";
import Slider from "@material-ui/lab/Slider";
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import { Chart } from "react-google-charts";
import CustomerAudience from "./CustomerAudience";
import CustomerTabs from "./CustomerTabs";
import CustSource from "./CustSource";
import AcqCustSource from "./AcqCustSource";
import CustSegment from "./CustSegment";
import Select from "react-select";
import LoadingOverlay from "react-loading-overlay";
import TextField from "@material-ui/core/TextField";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
var group = [];

let apiName = process.env.REACT_APP_AMPLIFY_API;

class CreateAudiences extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      channelsDropDown: [],
      channelModal: false,
      filtRule: " ",
      segRule: " ",
      tempquery_count: 0,
      tempfull_count: 0,
      tempaddress_count: 0,
      tempemail_count: 0,
      temppreview: 0,
      temptotal_audience_email_count: 0,
      temptotal_audience_email_pre: 0,
      temptotal_audience_email_eclub: 0,
      temptotal_non_mkt: 0,
      temptotal_mkt: 0,
      tempnon_eclub_emails: 0,
      tempnon_preclub_emails: 0,
      tempnon_email_custs: 0,
      tempnon_direct_mail: 0,
      isLoading: true,
      value: 0,
      clientId: "",
      query: "",
      customerType: "",
      alert: null,
      show: false,
      groupTitle: "",
      listDescription: "",
      tr: false,
      td: false,
      message: "",
      color: "success",
      open: false,
      classicModal: false,
      typeModal: false,
      changeModal: false,
      showAcquistion: false,
      showEclub: false,
      showCustomerConnect: false,
      defaultIndex: 0,
      tabIndex: 0,
      changeTab: false,
      fields: {},
      errors: {},
      created: false,
      count: 0,
      numChildren: 1,
      numGroup: 0,
      elements: [],
      redirect: false,
      lastModifiedDate: "",
      initalCreationDate: "",
      activeTab: "Filter",
      changeStatus: "no",
      isAcquistionClicked: false,
      excludedCount: 0,
      audienceCreatedId: 0,
      loadingInitalSpinner: "false",
      // activeTab: "No tab selected. So, no "
      localStorageClientId: "",

      // Changes for Prospect functionality // 17/8/2022
      prospectMinimumValue: "1000",
      maximumAudienceSize: "0",
      prospectControlRadius: "5",
      prospectInputsModal: false,
      prospectLimitsInputModal: false,
      localStorageGroupId: "",
      acquisitionChannelId: [
        { id: "d977fc2b-2352-473b-9a54-b80765f0400c" },
        { id: "79b91604-9f03-428a-9026-9be77ca9a687" },
        { id: "2c77a7b6-60e9-4c75-819e-e93b60d47b82" }
      ],
      customerChannelId: [
        { id: "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "d1606aea-0c0d-4fba-83e8-a124f414a953" },
        { id: "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" },
        { id: "3b3e90db-f06b-4ba4-9fbb-769637647ab0" },
        { id: "f786cb0f-eecc-4b87-adef-34eb20f3f766" },
        { id: "0417f699-bdd9-473d-873f-499e1c86efac" },
        { id: "g786cb0f-eecc-4b87-adef-34eb20f3f766" },
        { id: "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" },
        { id: "1d337d2d-e23a-445a-bda6-2405dbb79dcc" },
        { id: "25c7cb9a-a192-46f5-b32d-49e8d52afea8" },
        { id: "92ec41c7-6724-4891-bc17-24981a3261dd" },
        { id: "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "3c8a9cf7-a0b2-4845-8436-d598181e6d78" },
        { id: "c2a842ba-36cc-46b7-8fa4-3a361708b34b" },
        { id: "33bc71b1-4495-43f0-ab64-17ed38270e04" }
      ],
      combinedChannelId: [{ id: "2f524d19-d3d2-498f-bd73-8d68737e809d" }],
      prospectFiltRule: "",
      customerFiltRule: "",
      prospectSegRule: "",
      customerSegRule: "",
      audienceCappingModal: false,
      overlaySpinnerSummary: true,
      errorFlag: false,
      calculatedTotalProspects: 0,
      calculatedMarketableProspects: 0,
      calculatedControlProspects: 0,
      calculatedTotalCustomers: 0,
      calculatedMarketableCustomers: 0,
      calculatedControlCustomers: 0,
      prospectFilterRuleForAutomation: "", // To be used to save in the audiences table and use the condition in the Automations
      modelDecileFilterRuleForAutomation: "", // To be used to save in the audiences table and use the condition in the Automations
      samplingFilterRuleForAutomation: "", // To be used to save in the audiences table and use the condition in the Automations
      numberOfActiveLocations: 0,
      prospectsEnabledClientId: [
        "8c001fde-3728-48dc-9950-b8480ca9fbee", // BajaFresh
        "3fe7e557-16f5-406c-bbc8-887fdec7ba8b", // ColdStoneCreamery
        "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534", // Lou Malnatis
        "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c", // Brusters
        "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f", // BadDaddys
        "1857ba2f-010f-4f49-bcd1-f9fd09db2799", // Primanti Bros
        "b44cc84d-73b5-4457-bb48-68e9626d08e1", // VivaChicken
        "687c8c2a-0986-4147-bf38-0d5bac9f7530", // Eegee's
        "2b7ed789-e2d0-45c0-a45f-49e27d736a7b", // JGilbert's
        "7abec586-17b8-4174-993d-e3d86648ed60", // Houlihans Central
        "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406", // Houlihans NorthEast
        "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9", // SeaFood Grill
        "535a90f3-b463-4d5a-9a83-39c522589a6c", // Mambo
        "712cc8e9-3a79-4900-b122-ec9812e0f0ca", // Fridays
        "9501c9a1-6d0c-4285-a44f-64b1db4b3f91", // Charley's
        "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534", // Lou's
        "e722fa14-9dbd-11ee-8c90-0242ac120002", // ToC
        "4d288e9e-9254-4513-bb54-072b9f8fc882", // Flag Stop
        "31a73952-d1bf-4647-af62-204b1f56596c", // Pollo Tropical
        "d1522630-2b9d-424e-a399-7ab3f7be274f", // Lennys
        "7203dd51-f88b-4a4b-877c-92326d027915", // Planet Smoothie
        "cf6144d2-bb68-43b6-9876-dbf620b57c21", // Sweet Frog
        "83da098f-2fc7-4b98-8455-c08f9aceb4ed", // Taco Time
        "37f97bea-f005-4be1-8e41-286ad79a7f3a", // Bahamabucks
        "ec5a162e-5e87-4819-93bd-70bbf3b5f096", // Brio Bravo
        "24ab940a-50d2-41fd-b3b2-c67ca6cb0304", // New Demo Client
        "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac", // Bertucci
        "874b6c6a-83ff-480b-b615-1972538813ba", // Bravo
        "b76e7818-deb1-4526-93a7-b398df3ea357", // Goodtimes
        "e08840c5-c7d0-48c7-9c24-124b4cd80735", // Ruby Tuesdays
        "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e", // Firebirds
        "0bc2a383-9ae0-4e9e-9652-0fb762ba6119", // Wow Car Wash
        "7bf99619-30a3-47a3-b1de-d72b4f7f99a7", // Better Buzz
        "a4dda78e-7678-4aaf-9bef-60a229085fc8", // Smoothie King
      ], // Array consists of the client ids for which the prospects are enabled.

      summaryBoxHeaderText: "Summary",
    };
  }

  decryptLocal(item_id) {
    return JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem(item_id),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )
  }

  prospectMinimumOnChange = (event) => {
    this.setState({ prospectMinimumValue: event.target.value }, () => {
      localStorage.setItem(
        "prospectMinimumValueLocalStorage",
        CryptoJS.AES.encrypt(
          JSON.stringify(this.state.prospectMinimumValue),
          process.env.REACT_APP_PASS
        ).toString()
      );
    });
  };

  maximumAudienceSizeOnChange = (event) => {
    this.setState({ maximumAudienceSize: event.target.value }, () => {
      localStorage.setItem(
        "maximumAudienceSizeLocalStorage",
        CryptoJS.AES.encrypt(
          JSON.stringify(this.state.maximumAudienceSize),
          process.env.REACT_APP_PASS
        ).toString()
      );
    });
  };

  prospectControlRadiusOnChange = (event) => {
    this.setState({ prospectControlRadius: event.target.value });
  };

  // Prospect Limits Fetch Counts:

  fetchProspectCounts = async (event) => {
    if (
      this.state.prospectMinimumValue === "" ||
      this.state.prospectMinimumValue === undefined
    ) {
      let err = {};
      err["prospectsMinimum"] = "Please enter a valid value";
      this.setState({ errors: err });
      setTimeout(
        function () {
          this.setState({
            errors: (err["prospectsMinimum"] = ""),
          });
        }.bind(this),
        3000
      );
      return;
    }

    if (
      this.state.maximumAudienceSize === "" ||
      this.state.maximumAudienceSize === undefined
    ) {
      let err = {};
      err["maximumAudienceSize"] = "Please enter a valid value";
      this.setState({ errors: err });
      setTimeout(
        function () {
          this.setState({
            errors: (err["maximumAudience"] = ""),
          });
        }.bind(this),
        3000
      );
      return;
    }

    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: true,
    });
    let prospectSelectedRule = "";
    let customerSelectedRule = "";
    await this.getWhereForSave();

    let splittedSelectedRule = this.state.filtRule.split("AND");

    if (this.state.filtRule !== "") {
      splittedSelectedRule.forEach((element) => {
        if (element.includes("hh.")) {
          if (prospectSelectedRule === "") {
            prospectSelectedRule += element;
          } else {
            prospectSelectedRule += "AND " + element;
          }
        } else {
          if (customerSelectedRule === "") {
            customerSelectedRule += element;
          } else {
            customerSelectedRule += "AND " + element;
          }
        }
      });
    }

    this.setState({
      prospectInputsModal: false,
    });

    let clientName = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("conceptName"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    )

    let channel = "display";

    if (
      this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
      this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    ) {
      channel = "email";
    }

    fetch(
      "https://v56uvo3jhtilsarixxweiwahum0nrabn.lambda-url.us-west-2.on.aws/",
      {
        method: "post",
        body: JSON.stringify({
          maximumAudienceSizeParameterValue: this.state.maximumAudienceSize,
          prospectMinimumParameterValue: this.state.prospectMinimumValue,
          channelType: channel,
          nonModelDecileProspectFilterRule: this.state
            .prospectFilterRuleForAutomation,
          modelDecileProspectFilterRule: this.state
            .modelDecileFilterRuleForAutomation,
          samplingFilterRule: this.state.samplingFilterRuleForAutomation,
          clientName: clientName,
          selectedType: "filter",
        }),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log("Result", result);
        if (result.hasOwnProperty("ERROR")) {
          this.setState(
            {
              errorFlag: true,
            },
            () => {
              this.setState({
                overlaySpinnerSummary: false,
              });
            }
          );
        } else {
          this.props.dispatch({
            type: "CUST_UPDATE_QUERY_RESULT_JSON",
            filter_result_json: result.prospect_counts_channel,
          });
          this.props.dispatch({
            type: "CUST_UPDATE_OVERLAY_SPINNER",
            overlaySpinner: false,
          });

          this.setState(
            {
              calculatedTotalProspects:
                result.prospect_counts_channel.prospects.total,
              calculatedMarketableProspects:
                result.prospect_counts_channel.prospects.marketable,
              calculatedControlProspects:
                result.prospect_counts_channel.prospects.control,
            },
            () => {
              this.setState({
                overlaySpinnerSummary: false,
              });
            }
          );
        }
      });
  };

  handleclick = (activeTab) => {
    this.setState({ activeTab });
  };

  handleSliderChange = (event, value) => {
    let queryCount = 0;
    let queryCountData =
      this.state.customerType == "Acquistion"
        ? this.props.queryCount
        : this.props.cust_queryCount;
    if (
      queryCountData["query_count"] != "" &&
      queryCountData["query_count"] != " "
    ) {
      queryCount = queryCountData["query_count"];
    } else {
      queryCount =
        this.state.customerType == "Acquistion"
          ? this.props.queryCountTempSegment["query_count"]
          : this.props.cust_queryCountTempSegment["query_count"];
    }
    this.props.dispatch({
      type: "CHANGE_SLIDER_VALUE",
      payload: value,
      excludedCount: Math.round((queryCount * value) / 100),
    });
    // this.props.dispatch({ type: "Add"});
  };
  handleChannelDropDownChange = async (event) => {
    localStorage.setItem(
      "activeChannel",
      CryptoJS.AES.encrypt(JSON.stringify(event.value), process.env.REACT_APP_PASS).toString()
    );
    await this.getWhereForSave();
    let fQS = "";

    if (
      this.state.localStorageClientId ===
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    ) {
      fQS =
        "SELECT " +
        this.decryptLocal("channelsAllObj").filter(
          (obj) =>
            obj.id ===
            this.decryptLocal("activeChannel")
        )[0]["counts"] +
        " FROM " +
        this.decryptLocal("custDb") +
        ".cust_analytic ca LEFT JOIN " +
        this.decryptLocal("custDb") +
        ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        this.decryptLocal("custDb") +
        ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        this.decryptLocal("custDb") +
        ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        this.decryptLocal("custDb") +
        ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        this.decryptLocal("custDb") +
        ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
        this.decryptLocal("custDb") +
        ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
        this.decryptLocal("globalFilter") +
        " AND " +
        this.state.filtRule;
      // " AND ca.olo = true AND ca.loyalty = false";
      if (this.state.filtRule.includes("li.")) {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter(
            (obj) =>
              obj.id ===
              this.decryptLocal("activeChannel")
          )[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept left join " +
          this.decryptLocal("custDb").split("_")[0] +
          "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE " +
          this.decryptLocal("globalFilter") +
          " AND " +
          this.state.filtRule;
      }
      if (this.state.filtRule == "") {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter(
            (obj) =>
              obj.id ===
              this.decryptLocal("activeChannel")
          )[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".olo_customer oc on oc.cust_id = ca.cust_id LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          this.decryptLocal("globalFilter");
        // " AND ca.olo = true AND ca.loyalty = false";
      }
    } else {
      if (
        this.state.localStorageClientId ===
        "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        this.state.localStorageClientId ===
        "f0d3b19b-a564-43e9-85dd-bd95f8b13f97"
      ) {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter(
            (obj) =>
              obj.id ===
              this.decryptLocal("activeChannel")
          )[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
          this.decryptLocal("globalFilter") +
          " AND " +
          this.state.filtRule;
        if (this.state.filtRule.includes("li.")) {
          fQS =
            "SELECT " +
            this.decryptLocal("channelsAllObj").filter(
              (obj) =>
                obj.id ===
                this.decryptLocal("activeChannel")
            )[0]["counts"] +
            " FROM " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) LEFT JOIN " +
            this.decryptLocal("custDb").split("_")[0] +
            "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE " +
            this.decryptLocal("globalFilter") +
            " AND " +
            this.state.filtRule;
        }
        if (this.state.filtRule == "") {
          fQS =
            "SELECT " +
            this.decryptLocal("channelsAllObj").filter(
              (obj) =>
                obj.id ===
                this.decryptLocal("activeChannel")
            )[0]["counts"] +
            " FROM " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept AND (ec.email_address_hh = lo.email_address_hh OR ec.name_addr_key = lo.name_addr_key OR ec.phone_home = lo.loyalty_phone_home OR ec.phone_mobile = lo.loyalty_phone_mobile) WHERE " +
            this.decryptLocal("globalFilter");
        }
      } else {
        fQS =
          "SELECT " +
          this.decryptLocal("channelsAllObj").filter(
            (obj) =>
              obj.id ===
              this.decryptLocal("activeChannel")
          )[0]["counts"] +
          " FROM " +
          this.decryptLocal("custDb") +
          ".cust_analytic ca LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          this.decryptLocal("custDb") +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          this.decryptLocal("custDb") +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
          this.decryptLocal("globalFilter") +
          " AND " +
          this.state.filtRule;
        if (this.state.filtRule.includes("li.")) {
          fQS =
            "SELECT " +
            this.decryptLocal("channelsAllObj").filter(
              (obj) =>
                obj.id ===
                this.decryptLocal("activeChannel")
            )[0]["counts"] +
            " FROM " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept left join " +
            this.decryptLocal("custDb").split("_")[0] +
            "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE " +
            this.decryptLocal("globalFilter") +
            " AND " +
            this.state.filtRule;
        }
        if (this.state.filtRule == "") {
          fQS =
            "SELECT " +
            this.decryptLocal("channelsAllObj").filter(
              (obj) =>
                obj.id ===
                this.decryptLocal("activeChannel")
            )[0]["counts"] +
            " FROM " +
            this.decryptLocal("custDb") +
            ".cust_analytic ca LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
            this.decryptLocal("custDb") +
            ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
            this.decryptLocal("custDb") +
            ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
            this.decryptLocal("globalFilter");
        }
      }
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    ) {
      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "oc.email_marketable = true"
      );
      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "oc.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "lo.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "ec.email_marketable = true",
        "lo.email_marketable = true"
      );
    }

    if (
      this.decryptLocal("clientId") === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
      this.decryptLocal("activeChannel") === "92ec41c7-6724-4891-bc17-24981a3261dd"
    ) {
      fQS = fQS.replaceAll(
        "oc.email_marketable = true",
        "ec.email_marketable = true"
      );

      fQS = fQS.replaceAll(
        "lo.email_marketable = true",
        "ec.email_marketable = true"
      );
    }

    let myInitCount = {
      headers: {},
      body: {
        sql: fQS,
        isGeneral: true,
        custDb: this.decryptLocal("custDb"),
      },
    };
    this.props.dispatch({
      type: "CUST_UPDATE_OVERLAY_SPINNER",
      overlaySpinner: true,
    });
    API.post(apiName, "/counts", myInitCount)
      .then((response) => {
        if ("final_result" in response) {
          let y = this.decryptLocal("counts");
          let tempAC = this.decryptLocal("activeChannel");
          if (y.filter((x) => x.channelId === tempAC).length == 0) {
            y.push({
              channelId: tempAC,
              refreshedAt: Math.round(new Date().getTime() / 1000),
              counts: [JSON.parse(response["final_result"])],
            });
          } else {
            for (let i in y) {
              if (y[i]["channelId"] == tempAC) {
                y[i]["refreshedAt"] = Math.round(new Date().getTime() / 1000);
                y[i]["counts"] = [JSON.parse(response["final_result"])];
              }
            }
          }
          localStorage.setItem(
            "counts",
            CryptoJS.AES.encrypt(JSON.stringify(y), process.env.REACT_APP_PASS).toString()
          );
          this.props.dispatch({
            type: "CUST_UPDATE_QUERY_RESULT_JSON",
            filter_result_json: JSON.parse(response["final_result"]),
          });
          this.props.dispatch({
            type: "CUST_UPDATE_OVERLAY_SPINNER",
            overlaySpinner: false,
          });
        }
      })
      .catch((error) => { });
  };

  handleProspectsValidataion = () => {
    if (
      this.state.localStorageClientId ===
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
      this.state.localStorageClientId ===
      "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
      this.state.localStorageClientId ===
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
      this.state.localStorageClientId ===
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
      this.state.localStorageClientId ===
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
      this.state.localStorageClientId ===
      "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
      this.state.localStorageClientId ===
      "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
      this.state.localStorageClientId ===
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
      this.state.localStorageClientId ===
      "7abec586-17b8-4174-993d-e3d86648ed60" ||
      this.state.localStorageClientId ===
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
      this.state.localStorageClientId ===
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
      this.state.localStorageClientId ===
      "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
      this.state.localStorageClientId ===
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
      this.state.localStorageClientId ===
      "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
      this.state.localStorageClientId ===
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "31a73952-d1bf-4647-af62-204b1f56596c" ||
      this.state.localStorageClientId ===
      '4d288e9e-9254-4513-bb54-072b9f8fc882' ||
      this.state.localStorageClientId ===
      "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
      this.state.localStorageClientId ===
      "7203dd51-f88b-4a4b-877c-92326d027915" ||
      this.state.localStorageClientId === 
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
      this.state.localStorageClientId === 
      "874b6c6a-83ff-480b-b615-1972538813ba" ||
      this.state.localStorageClientId === 
      "b76e7818-deb1-4526-93a7-b398df3ea357" ||
      this.state.localStorageClientId === 
      "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
      this.state.localStorageClientId === 
        "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
      this.state.localStorageClientId === 
        "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
      this.state.localStorageClientId === 
        "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
      this.state.localStorageClientId === 
        "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
      this.state.localStorageClientId === 
        "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
      this.state.localStorageClientId === 
        "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
      this.state.localStorageClientId ===
       "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
      this.state.localStorageClientId ===
       "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
      this.state.localStorageClientId ===
       "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
    ) {
      if (
        this.state.prospectMinimumValue === "" ||
        this.state.prospectMinimumValue === undefined
      ) {
        let err = {};
        err["prospectsMinimum"] = "Please enter a valid value";
        this.setState({ errors: err });
        setTimeout(
          function () {
            this.setState({
              errors: (err["prospectsMinimum"] = ""),
            });
          }.bind(this),
          3000
        );
        return;
      }

      if (
        this.state.maximumAudienceSize === "" ||
        this.state.maximumAudienceSize === undefined
      ) {
        let err = {};
        err["maximumAudienceSize"] = "Please enter a valid value";
        this.setState({ errors: err });
        setTimeout(
          function () {
            this.setState({
              errors: (err["maximumAudience"] = ""),
            });
          }.bind(this),
          3000
        );
        return;
      }
    }
    this.setState({ prospectInputsModal: false });
  };

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    //Name
    if (!fields["groupTitle"] && this.state.groupTitle == "") {
      formIsValid = false;
      errors["groupTitle"] = "Please enter title";
      this.setState({
        message: "Please enter title",
        td: true,
      });
    }

    if (!fields["listDescription"] && this.state.listDescription == "") {
      formIsValid = false;
      errors["listDescription"] = "Please enter description";
      this.setState({
        message: "Please enter description",
        td: true,
      });
    }

    this.setState({ errors: errors });
    setTimeout(
      function () {
        this.setState({
          td: false,
          // message: ""
        });
        // this.props.history.push("/audiences/viewAudiences");
      }.bind(this),
      3000
    );
    return formIsValid;
  }
  prepareQueryData(response) {
    let query_count = " ";
    let full_count = " ";
    let address_count = " ";
    let email_count = " ";
    let preview = [];
    let total_audience_email_count = " ";
    let total_audience_email_pre = " ";
    let total_audience_email_eclub = " ";
    let total_non_mkt = " ";
    let total_mkt = " ";
    let non_eclub_emails = " ";
    let non_preclub_emails = " ";
    let non_email_custs = " ";
    let non_direct_mail = " ";
    if (
      response["final_result"] !== undefined &&
      response["final_result"]["Items"] !== undefined &&
      response["final_result"]["Items"].length > 0 &&
      response["final_result"]["Items"][0]["_col0"] !== undefined
    ) {
      query_count = response["final_result"]["Items"][0]["_col0"];
    }
    if (
      response["full_result"] !== undefined &&
      response["full_result"]["Items"] !== undefined &&
      response["full_result"]["Items"].length > 0 &&
      response["full_result"]["Items"][0]["_col0"] !== undefined
    ) {
      full_count = response["full_result"]["Items"][0]["_col0"];
    }
    if (
      response["address_result"] !== undefined &&
      response["address_result"]["Items"] !== undefined &&
      response["address_result"]["Items"].length > 0 &&
      response["address_result"]["Items"][0]["_col0"] !== undefined
    ) {
      address_count = response["address_result"]["Items"][0]["_col0"];
    }
    if (
      response["email_result"] !== undefined &&
      response["email_result"]["Items"] !== undefined &&
      response["email_result"]["Items"].length > 0 &&
      response["email_result"]["Items"][0]["_col0"] !== undefined
    ) {
      email_count = response["email_result"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience"] !== undefined &&
      response["total_audience"]["Items"] !== undefined &&
      response["total_audience"]["Items"].length > 0 &&
      response["total_audience"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_count =
        response["total_audience"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience_pre"] !== undefined &&
      response["total_audience_pre"]["Items"] !== undefined &&
      response["total_audience_pre"]["Items"].length > 0 &&
      response["total_audience_pre"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_pre =
        response["total_audience_pre"]["Items"][0]["_col0"];
    }
    if (
      response["total_audience_eclub"] !== undefined &&
      response["total_audience_eclub"]["Items"] !== undefined &&
      response["total_audience_eclub"]["Items"].length > 0 &&
      response["total_audience_eclub"]["Items"][0]["_col0"] !== undefined
    ) {
      total_audience_email_eclub =
        response["total_audience_eclub"]["Items"][0]["_col0"];
    }
    if (
      response["total_non_mkt"] !== undefined &&
      response["total_non_mkt"]["Items"] !== undefined &&
      response["total_non_mkt"]["Items"].length > 0 &&
      response["total_non_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_non_mkt = response["total_non_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["total_mkt"] !== undefined &&
      response["total_mkt"]["Items"] !== undefined &&
      response["total_mkt"]["Items"].length > 0 &&
      response["total_mkt"]["Items"][0]["_col0"] !== undefined
    ) {
      total_mkt = response["total_mkt"]["Items"][0]["_col0"];
    }
    if (
      response["non_eclub_emails"] !== undefined &&
      response["non_eclub_emails"]["Items"] !== undefined &&
      response["non_eclub_emails"]["Items"].length > 0 &&
      response["non_eclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_eclub_emails = response["non_eclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_preclub_emails"] !== undefined &&
      response["non_preclub_emails"]["Items"] !== undefined &&
      response["non_preclub_emails"]["Items"].length > 0 &&
      response["non_preclub_emails"]["Items"][0]["_col0"] !== undefined
    ) {
      non_preclub_emails = response["non_preclub_emails"]["Items"][0]["_col0"];
    }

    if (
      response["non_email_custs"] !== undefined &&
      response["non_email_custs"]["Items"] !== undefined &&
      response["non_email_custs"]["Items"].length > 0 &&
      response["non_email_custs"]["Items"][0]["_col0"] !== undefined
    ) {
      non_email_custs = response["non_email_custs"]["Items"][0]["_col0"];
    }

    if (
      response["non_direct_mail"] !== undefined &&
      response["non_direct_mail"]["Items"] !== undefined &&
      response["non_direct_mail"]["Items"].length > 0 &&
      response["non_direct_mail"]["Items"][0]["_col0"] !== undefined
    ) {
      non_direct_mail = response["non_direct_mail"]["Items"][0]["_col0"];
    }
    if (
      response["preview_result"] != undefined &&
      response["preview_result"]["Items"] != undefined
    ) {
      preview = response["preview_result"]["Items"];
    }

    this.setState({ tempquery_count: query_count });
    this.setState({ tempfull_count: full_count });
    this.setState({ tempaddress_count: address_count });
    this.setState({ tempemail_count: email_count });
    this.setState({ temppreview: preview });
    this.setState({
      temptotal_audience_email_count: total_audience_email_count,
    });
    this.setState({ temptotal_audience_email_pre: total_audience_email_pre });
    this.setState({
      temptotal_audience_email_eclub: total_audience_email_eclub,
    });
    this.setState({ temptotal_non_mkt: total_non_mkt });
    this.setState({ temptotal_mkt: total_mkt });
    this.setState({ tempnon_eclub_emails: non_eclub_emails });
    this.setState({ tempnon_preclub_emails: non_preclub_emails });
    this.setState({ tempnon_email_custs: non_email_custs });
    this.setState({ tempnon_direct_mail: non_direct_mail });
  }
  componentDidMount() {
    let v3ClientIdArray = [
      "8c001fde-3728-48dc-9950-b8480ca9fbee", // Baja Fresh
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799", // Primanti Bro's
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f", // Bad Daddy's
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534", // Lou Malnatis
      "687c8c2a-0986-4147-bf38-0d5bac9f7530", // Eegee's
      "b44cc84d-73b5-4457-bb48-68e9626d08e1", // Viva Chicken
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c", // Brusters
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca", // Fridays
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b", // ColdStoneCreamery
      "2bdbd6af-6cd3-4358-a1a0-437226a20ee9", // Goodwill
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b", // JGilbert's
      "7abec586-17b8-4174-993d-e3d86648ed60", // Houlihans Central
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406", // Houlihans NorthEast
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9", // SeaFood Grill
      "535a90f3-b463-4d5a-9a83-39c522589a6c", // Mambo
      "9501c9a1-6d0c-4285-a44f-64b1db4b3f91", // Charleys
      "acf275e9-3f68-4250-9f8a-e80672b133f3", // PJWhelihan's
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534", // Lou's
      "e722fa14-9dbd-11ee-8c90-0242ac120002", // ToC
      "31a73952-d1bf-4647-af62-204b1f56596c", // Pollo Tropical
      "4d288e9e-9254-4513-bb54-072b9f8fc882", // Flag Stop
      "d1522630-2b9d-424e-a399-7ab3f7be274f", // Lennys
      "7203dd51-f88b-4a4b-877c-92326d027915", // Planet Smoothie
      "cf6144d2-bb68-43b6-9876-dbf620b57c21", // Sweet Frog
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed", // Taco Time
      "37f97bea-f005-4be1-8e41-286ad79a7f3a", // Bahamabucks
      "ec5a162e-5e87-4819-93bd-70bbf3b5f096", // Brio Bravo
      "24ab940a-50d2-41fd-b3b2-c67ca6cb0304", // New Demo Client
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac", // Bertucci
      "874b6c6a-83ff-480b-b615-1972538813ba", // Bravo
      "b76e7818-deb1-4526-93a7-b398df3ea357", // Goodtimes
      "e08840c5-c7d0-48c7-9c24-124b4cd80735", // Ruby Tuesdays
      "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e", // Firebirds
      "0bc2a383-9ae0-4e9e-9652-0fb762ba6119", // Wow Car Wash
      "7bf99619-30a3-47a3-b1de-d72b4f7f99a7", // Better Buzz
      "a4dda78e-7678-4aaf-9bef-60a229085fc8", // Smoothie King
    ];
    this.setState(
      {
        localStorageClientId: this.decryptLocal("clientId"),
      },
      () => {
        if (v3ClientIdArray.includes(this.state.localStorageClientId)) {
          this.setState({
            summaryBoxHeaderText: "Post-Suppression Summary",
          });
        } else {
          this.setState({
            summaryBoxHeaderText: "Summary",
          });
        }

        // this.setState(
        //   {
        //     maximumAudienceSize:
        //       this.state.localStorageClientId ===
        //       "8c001fde-3728-48dc-9950-b8480ca9fbee"
        //         ? "365000"
        //         : this.state.localStorageClientId ===
        //           "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
        //           ? "4405000"
        //           : "380000",
        //   },
        //   () => {
        //     localStorage.setItem(
        //       "maximumAudienceSizeLocalStorage",
        //       CryptoJS.AES.encrypt(
        //         JSON.stringify(this.state.maximumAudienceSize),
        //         process.env.REACT_APP_PASS
        //       ).toString()
        //     );

        //     localStorage.setItem(
        //       "prospectMinimumValueLocalStorage",
        //       CryptoJS.AES.encrypt(
        //         JSON.stringify(this.state.prospectMinimumValue),
        //         process.env.REACT_APP_PASS
        //       ).toString()
        //     );
        //   }
        // );

        if (
          localStorage.getItem("numberOfActiveLocations") !== null &&
          localStorage.getItem("numberOfActiveLocations") !== undefined
        ) {
          this.setState(
            {
              numberOfActiveLocations: this.decryptLocal("clientId") === "e722fa14-9dbd-11ee-8c90-0242ac120002" ? 100000 :
                this.decryptLocal("numberOfActiveLocations") * 5000,
            },
            () => {
              this.setState(
                {
                  maximumAudienceSize: this.state.numberOfActiveLocations,
                },
                () => {
                  localStorage.setItem(
                    "maximumAudienceSizeLocalStorage",
                    CryptoJS.AES.encrypt(
                      JSON.stringify(this.state.maximumAudienceSize),
                      process.env.REACT_APP_PASS
                    ).toString()
                  );

                  localStorage.setItem(
                    "prospectMinimumValueLocalStorage",
                    CryptoJS.AES.encrypt(
                      JSON.stringify(this.state.prospectMinimumValue),
                      process.env.REACT_APP_PASS
                    ).toString()
                  );
                }
              );
            }
          );
        } else {
          let calculatedMaximumAudienceSizeValue = "";
          if (
            this.state.localStorageClientId ===
            "8c001fde-3728-48dc-9950-b8480ca9fbee"
          ) {
            calculatedMaximumAudienceSizeValue = "350000";
          } else if (
            this.state.localStorageClientId ===
            "3fe7e557-16f5-406c-bbc8-887fdec7ba8b"
          ) {
            calculatedMaximumAudienceSizeValue = "4575000";
          } else if (
            this.state.localStorageClientId ===
            "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534"
          ) {
            calculatedMaximumAudienceSizeValue = "390000";
          } else if (
            this.state.localStorageClientId ===
            "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c"
          ) {
            calculatedMaximumAudienceSizeValue = "965000";
          } else if (
            this.state.localStorageClientId ===
            "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f"
          ) {
            calculatedMaximumAudienceSizeValue = "200000";
          } else if (
            this.state.localStorageClientId ===
            "1857ba2f-010f-4f49-bcd1-f9fd09db2799"
          ) {
            calculatedMaximumAudienceSizeValue = "190000";
          } else if (
            this.state.localStorageClientId ===
            "b44cc84d-73b5-4457-bb48-68e9626d08e1"
          ) {
            calculatedMaximumAudienceSizeValue = "80000";
          } else if (
            this.state.localStorageClientId ===
            "687c8c2a-0986-4147-bf38-0d5bac9f7530"
          ) {
            calculatedMaximumAudienceSizeValue = "155000";
          } else if (
            this.state.localStorageClientId ===
            "2b7ed789-e2d0-45c0-a45f-49e27d736a7b"
          ) {
            calculatedMaximumAudienceSizeValue = "30000";
          } else if (
            this.state.localStorageClientId ===
            "7abec586-17b8-4174-993d-e3d86648ed60"
          ) {
            calculatedMaximumAudienceSizeValue = "50000";
          } else if (
            this.state.localStorageClientId ===
            "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406"
          ) {
            calculatedMaximumAudienceSizeValue = "45000";
          } else if (
            this.state.localStorageClientId ===
            "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9"
          ) {
            calculatedMaximumAudienceSizeValue = "30000";
          } else if (
            this.state.localStorageClientId ===
            "535a90f3-b463-4d5a-9a83-39c522589a6c"
          ) {
            calculatedMaximumAudienceSizeValue = "55000";
          } else if (
            this.state.localStorageClientId ===
            "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
          ) {
            calculatedMaximumAudienceSizeValue = "1425000";
          } else if (
            this.state.localStorageClientId ===
            "9501c9a1-6d0c-4285-a44f-64b1db4b3f91"
          ) {
            calculatedMaximumAudienceSizeValue = "3805000";
          } else if (
            this.state.localStorageClientId ===
            "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534"
          ) {
            calculatedMaximumAudienceSizeValue = "390000";
          }
          else if (
            this.state.localStorageClientId ===
            "e722fa14-9dbd-11ee-8c90-0242ac120002"
          ) {
            calculatedMaximumAudienceSizeValue = "390000";
          }
          else if (
            this.state.localStorageClientId ===
            "31a73952-d1bf-4647-af62-204b1f56596c"
          ) {
            calculatedMaximumAudienceSizeValue = "3900000";
          }
          else if (
            this.state.localStorageClientId ===
            "4d288e9e-9254-4513-bb54-072b9f8fc882"
          ) {
            calculatedMaximumAudienceSizeValue = "3900000";
          }
          else if (
            this.state.localStorageClientId ===
            "d1522630-2b9d-424e-a399-7ab3f7be274f"
          ) {
            calculatedMaximumAudienceSizeValue = "3900000";
          }
          else if (
            this.state.localStorageClientId ===
            "7203dd51-f88b-4a4b-877c-92326d027915"  ||
            this.state.localStorageClientId ===
            "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId === 
            "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId === 
              "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
            this.state.localStorageClientId === 
              "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId === 
              "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
            this.state.localStorageClientId === 
              "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === 
              "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === 
              "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === 
              "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId ===
              "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId ===
              "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId ===
              "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
            this.state.localStorageClientId ===
              "535a90f3-b463-4d5a-9a83-39c522589a6c"
          ) {
            calculatedMaximumAudienceSizeValue = "3900000";
          }

          this.setState(
            {
              maximumAudienceSize: calculatedMaximumAudienceSizeValue,
            },
            () => {
              localStorage.setItem(
                "maximumAudienceSizeLocalStorage",
                CryptoJS.AES.encrypt(
                  JSON.stringify(this.state.maximumAudienceSize),
                  process.env.REACT_APP_PASS
                ).toString()
              );

              localStorage.setItem(
                "prospectMinimumValueLocalStorage",
                CryptoJS.AES.encrypt(
                  JSON.stringify(this.state.prospectMinimumValue),
                  process.env.REACT_APP_PASS
                ).toString()
              );
            }
          );
        }
      }
    );
    this.setState({
      localStorageGroupId: this.decryptLocal("groupId"),
    });
    setTimeout(
      function () {
        this.setState({ loadingInitalSpinner: "false" });
      }.bind(this),
      12000
    );
    let cAllObj = this.decryptLocal("channelsAllObj");
    let optionsArray = [];
    for (let i in cAllObj) {
      if (cAllObj[i]["display"] == true) {
        let obj = {};
        obj["label"] = cAllObj[i]["program"];
        obj["value"] = cAllObj[i]["id"];
        optionsArray.push(obj);
      }
    }
    this.setState({ channelsDropDown: optionsArray });
    /*let fQS = "select count(distinct(ca.cust_id)) all_custs, count(distinct(if(ca.global_control_flag = false and ec.email_marketable = true, ec.cust_id))) eclub_custs, count(distinct(if(ca.global_control_flag = false and ec.email_marketable = true, ec.email_address))) eclub_emails, count(distinct(if(ca.global_control_flag = true and ec.email_marketable = true, ec.email_address))) non_eclub_emails, count(distinct(if(ca.global_control_flag = false and oe.clean = true, oe.cust_id))) preclub_custs, count(distinct(if(ca.global_control_flag = false and oe.clean = true, oe.email_address))) preclub_emails, count(distinct(if(ca.global_control_flag = true and oe.clean = true, oe.email_address))) non_preclub_emails, count(distinct(coalesce(if(ca.global_control_flag = false and ec.email_marketable = true, ec.cust_id), if(ca.global_control_flag = false and oe.clean = true, oe.cust_id)))) email_custs, count(distinct(coalesce(if(ca.global_control_flag = true and ec.email_marketable = true, ec.cust_id), if(ca.global_control_flag = true and oe.clean = true, oe.cust_id)))) non_email_custs, count(distinct(if(ca.global_control_flag = false, ci.cust_id))) direct_mail, count(distinct(if(ca.global_control_flag = true, ci.cust_id))) non_direct_mail, count(distinct(coalesce( if(ca.global_control_flag = true and ec.email_marketable = true, ec.cust_id), if(ca.global_control_flag = true and oe.clean = true, oe.cust_id), if(ca.global_control_flag = true, ci.cust_id) ))) non_mkt, count(distinct(coalesce( if(ca.global_control_flag = false and ec.email_marketable = true, ec.cust_id), if(ca.global_control_flag = false and oe.clean = true, oe.cust_id), if(ca.global_control_flag = false, ci.cust_id) ))) mkt from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".cust_analytic ca left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".client_intellibase ci on ci.cust_id = ca.cust_id left join ( select * from ( select rank() over (partition by email_address, geo_concept order by em_match_level, cust_id) rank, * from " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".owned_email ) where rank = 1 ) oe on oe.cust_id = ca.cust_id and oe.geo_concept = ca.geo_concept left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".eclub ec on ec.cust_id = ca.cust_id and ec.eclub_geo_concept = ca.geo_concept left join " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".geo geo on geo.geo_id = ca.geo_id_fav and geo.geo_concept = ca.geo_concept where " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('globalFilter'),'secretpass').toString(CryptoJS.enc.Utf8)); 
    let myInitCount = {
      headers: {},
      body: {
        sql: fQS,
        isCustFilter: true,
        custDb: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8))
      }
    };

    API.post(apiName, "/counts", myInitCount)
    .then(response => {
      this.prepareQueryData(response);
      this.setState({loadingInitalSpinner : 'false'});
    })
    .catch(error => {
      console.log('Error');
    });*/
    if (this.props.id !== undefined && this.props.id !== "") {
      let path = "/audiences";
      let myInit1 = {
        headers: {
          id: this.props.id,
        },
      };
      //Will fetch all the pre selected selections
      API.get(apiName, path, myInit1)
        .then((response) => {
          localStorage.setItem(
            "selectedCustomerType",
            CryptoJS.AES.encrypt(
              JSON.stringify(response[0]["customerType"]),
              process.env.REACT_APP_PASS
            ).toString()
          );

          localStorage.setItem(
            "maximumAudienceSizeLocalStorage",
            CryptoJS.AES.encrypt(
              JSON.stringify(response[0]["maximumAudienceSize"]),
              process.env.REACT_APP_PASS
            ).toString()
          );

          localStorage.setItem(
            "prospectMinimumValueLocalStorage",
            CryptoJS.AES.encrypt(
              JSON.stringify(response[0]["prospectMinimum"]),
              process.env.REACT_APP_PASS
            ).toString()
          );
          if ("counts" in response[0]) {
            localStorage.setItem(
              "counts",
              CryptoJS.AES.encrypt(
                JSON.stringify(response[0]["counts"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
            localStorage.setItem(
              "selectedCustomerType",
              CryptoJS.AES.encrypt(
                JSON.stringify(response[0]["customerType"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
            let t_counts = response[0]["counts"];
            t_counts.sort((a, b) => (a.refreshedAt > b.refreshedAt ? -1 : 1));
            localStorage.setItem(
              "activeChannel",
              CryptoJS.AES.encrypt(
                JSON.stringify(t_counts[0]["channelId"]),
                process.env.REACT_APP_PASS
              ).toString()
            );
          }

          ///Prospect Specific changes

          this.setState({
            prospectMinimumValue:
              response[0]["prospectMinimum"] !== ""
                ? response[0]["prospectMinimum"]
                : this.state.prospectMinimumValue,
            // audienceFloor:
            //   response[0]["audienceFloor"] !== ""
            //     ? response[0]["audienceFloor"]
            //     : this.state.audienceFloor,
            maximumAudienceSize:
              response[0]["maximumAudienceSize"] !== ""
                ? response[0]["maximumAudienceSize"]
                : this.state.maximumAudienceSize,
            // customerControlPanelSize:
            //   response[0]["customerControlPanelSize"] !== ""
            //     ? response[0]["customerControlPanelSize"]
            //     : this.state.customerControlPanelSize,
            // prospectControlPanelSize:
            //   response[0]["prospectControlPanelSize"] !== ""
            //     ? response[0]["prospectControlPanelSize"]
            //     : this.state.prospectControlPanelSize,
            prospectControlRadius:
              response[0]["prospectControlRadius"] !== ""
                ? response[0]["prospectControlRadius"]
                : this.state.prospectControlRadius,
          });

          // if (response[0]["customerType"] == "Acquistion") {
          //   this.setState({
          //     isAcquistionClicked: true,
          //     isCustomerClicked: false,
          //   });
          //   let ruleLeveltoggle = "";
          //   let groupLeveltoggle = "";
          //   let tillSqlSelectionArr = "";
          //   let afterSqlSelectionArr = "";
          //   let ruleLeveltoggleSegment = "";
          //   let groupLeveltoggleSegment = "";
          //   let tillSqlSelectionArrSegment = "";
          //   let afterSqlSelectionArrSegment = "";
          //   let segmentNames = [];
          //   if ("segmentName" in response[0]) {
          //     segmentNames = response[0]["segmentName"];
          //   }
          //   if ("groupLeveltoggleSegment" in response[0]) {
          //     groupLeveltoggleSegment = response[0]["groupLeveltoggleSegment"];
          //   }
          //   if ("ruleLeveltoggleSegment" in response[0]) {
          //     ruleLeveltoggleSegment = response[0]["ruleLeveltoggleSegment"];
          //   }
          //   if ("bSqlSelectionArrSegment" in response[0]) {
          //     tillSqlSelectionArrSegment =
          //       response[0]["bSqlSelectionArrSegment"];
          //   }
          //   if ("aSqlSelectionArrSegment" in response[0]) {
          //     afterSqlSelectionArrSegment =
          //       response[0]["aSqlSelectionArrSegment"];
          //   }

          //   if ("groupLeveltoggle" in response[0]) {
          //     groupLeveltoggle = response[0]["groupLeveltoggle"];
          //   }
          //   if ("ruleLeveltoggle" in response[0]) {
          //     ruleLeveltoggle = response[0]["ruleLeveltoggle"];
          //   }
          //   if ("bSqlSelectionArr" in response[0]) {
          //     tillSqlSelectionArr = response[0]["bSqlSelectionArr"];
          //   }
          //   if ("aSqlSelectionArr" in response[0]) {
          //     afterSqlSelectionArr = response[0]["aSqlSelectionArr"];
          //   }
          //   let date = new Date(response[0]["modifiedAt"]);
          //   let modifiedDate =
          //     (date.getMonth() + 1 > 9
          //       ? date.getMonth() + 1
          //       : "0" + (date.getMonth() + 1)) +
          //     "/" +
          //     date.getDate() +
          //     "/" +
          //     date.getFullYear();
          //   this.setState({
          //     groupTitle: response[0]["title"],
          //     listDescription: response[0]["description"],
          //     lastModifiedDate: modifiedDate,
          //     initalCreationDate: response[0]["createdAt"],
          //     customerType: response[0]["customerType"],
          //   });
          //   this.props.dispatch({
          //     type: "EDIT_AUDIENCE",
          //     tillSqlSelectionArr: tillSqlSelectionArr,
          //     afterSqlSelectionArr: afterSqlSelectionArr,
          //     groupLeveltoggle: groupLeveltoggle,
          //     ruleLeveltoggle: ruleLeveltoggle,
          //     title: response[0]["title"],
          //     listDescription: response[0]["description"],
          //     createdAt: response[0]["createdAt"],
          //     customerType: response[0]["customerType"],
          //   });
          //   this.props.dispatch({
          //     type: "EDIT_AUDIENCE_SEGMENT",
          //     tillSqlSelectionArrSegment: tillSqlSelectionArrSegment,
          //     afterSqlSelectionArrSegment: afterSqlSelectionArrSegment,
          //     groupLeveltoggleSegment: groupLeveltoggleSegment,
          //     ruleLeveltoggleSegment: ruleLeveltoggleSegment,
          //     segmentName: segmentNames,
          //     segmentData: [],
          //   });
          //   let self = this;
          //   self.props.dispatch({ type: "Add" });
          //   this.setState({ isLoading: false });

          if (response[0]["customerType"] === "Acquistion") {
            this.setState({
              isCustomerClicked: false,
              isAcquistionClicked: true,
            });
          } else {
            this.setState({
              isCustomerClicked: true,
              isAcquistionClicked: false,
            });
          }

          // if (response[0]["customerType"] == "Acquistion") {
          // } else if (response[0]["customerType"] == "Customer") {
          //   this.setState({
          //     isCustomerClicked: true,
          //     isAcquistionClicked: false,
          //   });

          //   let ruleLeveltoggle = "";
          //   let groupLeveltoggle = "";
          //   let tillSqlSelectionArr = "";
          //   let afterSqlSelectionArr = "";
          //   let ruleLeveltoggleSegment = "";
          //   let groupLeveltoggleSegment = "";
          //   let tillSqlSelectionArrSegment = "";
          //   let afterSqlSelectionArrSegment = "";
          //   let segmentNames = [];
          //   if ("segmentName" in response[0]) {
          //     segmentNames = response[0]["segmentName"];
          //   }
          //   if ("groupLeveltoggleSegment" in response[0]) {
          //     groupLeveltoggleSegment = response[0]["groupLeveltoggleSegment"];
          //   }
          //   if ("ruleLeveltoggleSegment" in response[0]) {
          //     ruleLeveltoggleSegment = response[0]["ruleLeveltoggleSegment"];
          //   }
          //   if ("bSqlSelectionArrSegment" in response[0]) {
          //     tillSqlSelectionArrSegment =
          //       response[0]["bSqlSelectionArrSegment"];
          //   }
          //   if ("aSqlSelectionArrSegment" in response[0]) {
          //     afterSqlSelectionArrSegment =
          //       response[0]["aSqlSelectionArrSegment"];
          //   }

          //   if ("groupLeveltoggle" in response[0]) {
          //     groupLeveltoggle = response[0]["groupLeveltoggle"];
          //   }
          //   if ("ruleLeveltoggle" in response[0]) {
          //     ruleLeveltoggle = response[0]["ruleLeveltoggle"];
          //   }
          //   if ("bSqlSelectionArr" in response[0]) {
          //     tillSqlSelectionArr = response[0]["bSqlSelectionArr"];
          //   }
          //   if ("aSqlSelectionArr" in response[0]) {
          //     afterSqlSelectionArr = response[0]["aSqlSelectionArr"];
          //   }
          //   let date = new Date(response[0]["modifiedAt"]);
          //   let modifiedDate =
          //     (date.getMonth() + 1 > 9
          //       ? date.getMonth() + 1
          //       : "0" + (date.getMonth() + 1)) +
          //     "/" +
          //     date.getDate() +
          //     "/" +
          //     date.getFullYear();
          //   this.setState({
          //     groupTitle: response[0]["title"],
          //     listDescription: response[0]["description"],
          //     lastModifiedDate: modifiedDate,
          //     initalCreationDate: response[0]["createdAt"],
          //     customerType: response[0]["customerType"],
          //   });
          //   this.props.dispatch({
          //     type: "CUST_EDIT_AUDIENCE",
          //     cust_tillSqlSelectionArr: tillSqlSelectionArr,
          //     cust_afterSqlSelectionArr: afterSqlSelectionArr,
          //     cust_groupLeveltoggle: groupLeveltoggle,
          //     cust_ruleLeveltoggle: ruleLeveltoggle,
          //     title: response[0]["title"],
          //     listDescription: response[0]["description"],
          //     createdAt: response[0]["createdAt"],
          //     customerType: response[0]["customerType"],
          //   });
          //   this.props.dispatch({
          //     type: "CUST_EDIT_AUDIENCE_SEGMENT",
          //     cust_tillSqlSelectionArrSegment: tillSqlSelectionArrSegment,
          //     cust_afterSqlSelectionArrSegment: afterSqlSelectionArrSegment,
          //     cust_groupLeveltoggleSegment: groupLeveltoggleSegment,
          //     cust_ruleLeveltoggleSegment: ruleLeveltoggleSegment,
          //     cust_segmentName: segmentNames,
          //     cust_segmentData: [],
          //   });
          //   let self = this;
          //   self.props.dispatch({ type: "CUST_Add" });
          //   this.setState({ isLoading: false });
          // }

          if (
            response[0]["customerType"] === "Customer" ||
            response[0]["customerType"] === "Acquistion" ||
            response[0]["customerType"] === "Combined"
          ) {
            {
              (this.state.localStorageClientId ===
                "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                this.state.localStorageClientId ===
                "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                this.state.localStorageClientId ===
                "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                this.state.localStorageClientId ===
                "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
                this.state.localStorageClientId ===
                "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
                this.state.localStorageClientId ===
                "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
                this.state.localStorageClientId ===
                "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
                this.state.localStorageClientId ===
                "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
                this.state.localStorageClientId ===
                "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
                this.state.localStorageClientId ===
                "7abec586-17b8-4174-993d-e3d86648ed60" ||
                this.state.localStorageClientId ===
                "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
                this.state.localStorageClientId ===
                "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
                this.state.localStorageClientId ===
                "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
                this.state.localStorageClientId ===
                "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
                this.state.localStorageClientId ===
                "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
                this.state.localStorageClientId ===
                "acf275e9-3f68-4250-9f8a-e80672b133f3" ||
                this.state.localStorageClientId ===
                "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                this.state.localStorageClientId ===
                "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
                this.state.localStorageClientId ===
                "31a73952-d1bf-4647-af62-204b1f56596c" ||
                this.state.localStorageClientId ===
                "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
                this.state.localStorageClientId ===
                "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                this.state.localStorageClientId ===
                "7203dd51-f88b-4a4b-877c-92326d027915" ||
                this.state.localStorageClientId ===
                "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                this.state.localStorageClientId === 
                "874b6c6a-83ff-480b-b615-1972538813ba" ||
                this.state.localStorageClientId === 
                  "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                this.state.localStorageClientId === 
                  "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
                this.state.localStorageClientId === 
                  "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                this.state.localStorageClientId === 
                  "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                this.state.localStorageClientId === 
                  "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                this.state.localStorageClientId === 
                  "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                this.state.localStorageClientId === 
                  "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                this.state.localStorageClientId === 
                  "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                this.state.localStorageClientId ===
                  "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                this.state.localStorageClientId ===
                  "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                this.state.localStorageClientId ===
                  "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
                this.setUpdatedChannelsDropdown(response[0]["customerType"]);
            }
            let ruleLeveltoggle = "";
            let groupLeveltoggle = "";
            let tillSqlSelectionArr = "";
            let afterSqlSelectionArr = "";
            let ruleLeveltoggleSegment = "";
            let groupLeveltoggleSegment = "";
            let tillSqlSelectionArrSegment = "";
            let afterSqlSelectionArrSegment = "";
            let segmentNames = [];
            if ("segmentName" in response[0]) {
              segmentNames = response[0]["segmentName"];
            }
            if ("groupLeveltoggleSegment" in response[0]) {
              groupLeveltoggleSegment = response[0]["groupLeveltoggleSegment"];
            }
            if ("ruleLeveltoggleSegment" in response[0]) {
              ruleLeveltoggleSegment = response[0]["ruleLeveltoggleSegment"];
            }
            if ("bSqlSelectionArrSegment" in response[0]) {
              tillSqlSelectionArrSegment =
                response[0]["bSqlSelectionArrSegment"];
            }
            if ("aSqlSelectionArrSegment" in response[0]) {
              afterSqlSelectionArrSegment =
                response[0]["aSqlSelectionArrSegment"];
            }

            if ("groupLeveltoggle" in response[0]) {
              groupLeveltoggle = response[0]["groupLeveltoggle"];
            }
            if ("ruleLeveltoggle" in response[0]) {
              ruleLeveltoggle = response[0]["ruleLeveltoggle"];
            }
            if ("bSqlSelectionArr" in response[0]) {
              tillSqlSelectionArr = response[0]["bSqlSelectionArr"];
            }
            if ("aSqlSelectionArr" in response[0]) {
              afterSqlSelectionArr = response[0]["aSqlSelectionArr"];
            }
            let date = new Date(response[0]["modifiedAt"]);
            let modifiedDate =
              (date.getMonth() + 1 > 9
                ? date.getMonth() + 1
                : "0" + (date.getMonth() + 1)) +
              "/" +
              date.getDate() +
              "/" +
              date.getFullYear();
            this.setState({
              groupTitle: response[0]["title"],
              listDescription: response[0]["description"],
              lastModifiedDate: modifiedDate,
              initalCreationDate: response[0]["createdAt"],
              customerType: response[0]["customerType"],
            });
            this.props.dispatch({
              type: "CUST_EDIT_AUDIENCE",
              cust_tillSqlSelectionArr: tillSqlSelectionArr,
              cust_afterSqlSelectionArr: afterSqlSelectionArr,
              cust_groupLeveltoggle: groupLeveltoggle,
              cust_ruleLeveltoggle: ruleLeveltoggle,
              title: response[0]["title"],
              listDescription: response[0]["description"],
              createdAt: response[0]["createdAt"],
              customerType: response[0]["customerType"],
            });
            this.props.dispatch({
              type: "CUST_EDIT_AUDIENCE_SEGMENT",
              cust_tillSqlSelectionArrSegment: tillSqlSelectionArrSegment,
              cust_afterSqlSelectionArrSegment: afterSqlSelectionArrSegment,
              cust_groupLeveltoggleSegment: groupLeveltoggleSegment,
              cust_ruleLeveltoggleSegment: ruleLeveltoggleSegment,
              cust_segmentName: segmentNames,
              cust_segmentData: [],
            });
            let self = this;
            self.props.dispatch({ type: "CUST_Add" });
            this.setState({ isLoading: false });
          }
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          console.log(error);
        });
    } else {
      let defaultcust_tillSqlSelectionArr = [
        [
          [
            {
              label: "Relationship",
              value: "Relationship",
            },
            {
              label: "Active Customer Flag",
              value: "ca.cust_active",
            },
            {
              label: "is equal to (==)",
              value: "=",
            },
          ],
          [
            {
              label: "Location",
              value: "Location",
            },
            {
              label: "Favorite Location/Store is Open",
              value: "geo.geo_active",
            },
            {
              label: "is equal to (==)",
              value: "=",
            },
          ],
        ],
      ];
      let defaultcust_afterSqlSelectionArr = [
        [
          [
            {
              label: "Yes",
              value: true,
            },
          ],
          [
            {
              label: "Yes",
              value: true,
            },
          ],
        ],
      ];
      let defaultcust_groupLeveltoggle = [];
      let defaultcust_ruleLeveltoggle = [["AND"]];
      if (
        this.decryptLocal("model") == "restaurant_v2"
      ) {
        defaultcust_tillSqlSelectionArr = [
          [
            [
              {
                label: "Relationship",
                value: "Relationship",
              },
              {
                label: "Active Customer Flag",
                value: "ca.cust_active",
              },
              {
                label: "is equal to (==)",
                value: "=",
              },
            ],
            [
              {
                label: "Location",
                value: "Location",
              },
              {
                label: "Favorite Location Participating in Guest Connect",
                value: "geo.geo_preclub",
              },
              {
                label: "is equal to (==)",
                value: "=",
              },
            ],
          ],
        ];
      }
      let channelFiltersObj = this.decryptLocal("channelsAllObj").filter(
        (obj) =>
          obj.id ===
          this.decryptLocal("activeChannel")
      )[0]["channelFilters"];
      for (let eachcust_tillSqlSelectionArr in channelFiltersObj[
        "cust_tillSqlSelectionArr"
      ]) {
        defaultcust_tillSqlSelectionArr.push(
          channelFiltersObj["cust_tillSqlSelectionArr"][
          eachcust_tillSqlSelectionArr
          ]
        );
      }
      for (let eachcust_afterSqlSelectionArr in channelFiltersObj[
        "cust_afterSqlSelectionArr"
      ]) {
        defaultcust_afterSqlSelectionArr.push(
          channelFiltersObj["cust_afterSqlSelectionArr"][
          eachcust_afterSqlSelectionArr
          ]
        );
      }
      for (let eachcust_groupLeveltoggle in channelFiltersObj[
        "cust_groupLeveltoggle"
      ]) {
        defaultcust_groupLeveltoggle.push(
          channelFiltersObj["cust_groupLeveltoggle"][eachcust_groupLeveltoggle]
        );
      }
      for (let eachcust_ruleLeveltoggle in channelFiltersObj[
        "cust_ruleLeveltoggle"
      ]) {
        defaultcust_ruleLeveltoggle.push(
          channelFiltersObj["cust_ruleLeveltoggle"][eachcust_ruleLeveltoggle]
        );
      }
      this.setState({ isLoading: false });
      this.props.dispatch({
        type: "EDIT_AUDIENCE",
        tillSqlSelectionArr: "",
        afterSqlSelectionArr: "",
        groupLeveltoggle: "",
        ruleLeveltoggle: "",
      });
      this.props.dispatch({
        type: "EDIT_AUDIENCE_SEGMENT",
        tillSqlSelectionArrSegment: "",
        afterSqlSelectionArrSegment: "",
        groupLeveltoggleSegment: "",
        ruleLeveltoggleSegment: "",
        segmentName: [],
      });
      this.props.dispatch({
        type: "CUST_EDIT_AUDIENCE",
        cust_tillSqlSelectionArr: defaultcust_tillSqlSelectionArr,
        cust_afterSqlSelectionArr: defaultcust_afterSqlSelectionArr, //aSqlSelectionArr
        cust_groupLeveltoggle: defaultcust_groupLeveltoggle, //groupLeveltoggle
        cust_ruleLeveltoggle: defaultcust_ruleLeveltoggle, // ruleLeveltoggle
      });
      this.props.dispatch({
        type: "CUST_EDIT_AUDIENCE_SEGMENT",
        cust_tillSqlSelectionArrSegment: "",
        cust_afterSqlSelectionArrSegment: "",
        cust_groupLeveltoggleSegment: "",
        cust_ruleLeveltoggleSegment: "",
        cust_segmentName: [],
      });
      this.handleClickOpen("typeModal");
    }
    let path = "/users";
    let custHeaders = {
      headers: {
        userId: this.decryptLocal("userId"),
      },
    };
    //Gets the user Id from the localstorage and fectches the user record from cmp-users
    API.get(apiName, path, custHeaders)
      .then((response) => {
        this.setState({
          clientId: this.decryptLocal("clientId"),
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  numberWithCommas(x) {
    return x != undefined
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  }

  propercase(str) {
    str = str.replaceAll("_", " ");
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  handleChangeInput = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    let fields = this.state.fields;
    fields[event.target.id] = event.target.value;
    this.setState({ fields });
  };
  setChangeTab() {
    this.setState({ changeTab: true });
    this.handleClose("changeModal");
  }
  setChannelToCustType(cT) {
    this.setState({ customerType: cT });

    localStorage.setItem(
      "selectedCustomerType",
      CryptoJS.AES.encrypt(JSON.stringify(cT), process.env.REACT_APP_PASS).toString()
    );
    if (
      this.state.localStorageClientId ===
      "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
      this.state.localStorageClientId ===
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
      this.state.localStorageClientId ===
      "d680b646-86d8-4d6c-b268-1ed505dc9de0" ||
      this.state.localStorageClientId ===
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
      this.state.localStorageClientId ===
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
      this.state.localStorageClientId ===
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
      this.state.localStorageClientId ===
      "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
      this.state.localStorageClientId ===
      "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
      this.state.localStorageClientId ===
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
      this.state.localStorageClientId ===
      "7abec586-17b8-4174-993d-e3d86648ed60" ||
      this.state.localStorageClientId ===
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
      this.state.localStorageClientId ===
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
      this.state.localStorageClientId ===
      "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
      this.state.localStorageClientId ===
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
      this.state.localStorageClientId ===
      "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
      this.state.localStorageClientId ===
      "acf275e9-3f68-4250-9f8a-e80672b133f3" ||
      this.state.localStorageClientId ===
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "31a73952-d1bf-4647-af62-204b1f56596c" ||
      this.state.localStorageClientId ===
      "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
      this.state.localStorageClientId ===
      "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
      this.state.localStorageClientId ===
      "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
      this.state.localStorageClientId ===
      "7203dd51-f88b-4a4b-877c-92326d027915" ||
      this.state.localStorageClientId ===
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
      this.state.localStorageClientId === 
      "874b6c6a-83ff-480b-b615-1972538813ba" ||
      this.state.localStorageClientId === 
      "b76e7818-deb1-4526-93a7-b398df3ea357" ||
      this.state.localStorageClientId === 
        "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
      this.state.localStorageClientId === 
        "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
      this.state.localStorageClientId === 
        "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
      this.state.localStorageClientId === 
        "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
      this.state.localStorageClientId === 
        "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
      this.state.localStorageClientId === 
        "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
      this.state.localStorageClientId === 
        "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
      this.state.localStorageClientId ===
        "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
      this.state.localStorageClientId ===
        "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
      this.state.localStorageClientId ===
        "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
    ) {
      let completeChannelsArray = this.decryptLocal("channelsAllObj");
      let myArrayFiltered = [];
      if (cT === "Acquistion") {
        myArrayFiltered = completeChannelsArray.filter((el) => {
          return this.state.acquisitionChannelId.some((f) => {
            return f.id === el.id;
          });
        });

        localStorage.setItem(
          "channelsAllObj",
          CryptoJS.AES.encrypt(
            JSON.stringify(myArrayFiltered),
            process.env.REACT_APP_PASS
          ).toString()
        );
      } else if (cT === "Customer") {
        myArrayFiltered = completeChannelsArray.filter((el) => {
          return this.state.customerChannelId.some((f) => {
            return f.id === el.id;
          });
        });

        // const swapPositions = (myArrayFiltered, a, b) => {
        //   [myArrayFiltered[a], myArrayFiltered[b]] = [
        //     myArrayFiltered[b],
        //     myArrayFiltered[a],
        //   ];
        // };
        // swapPositions(myArrayFiltered, 0, 1);
        // swapPositions(myArrayFiltered, 1, 2);

        localStorage.setItem(
          "channelsAllObj",
          CryptoJS.AES.encrypt(
            JSON.stringify(myArrayFiltered),
            process.env.REACT_APP_PASS
          ).toString()
        );
      } else {
        myArrayFiltered = completeChannelsArray.filter((el) => {
          return this.state.combinedChannelId.some((f) => {
            return f.id === el.id;
          });
        });

        localStorage.setItem(
          "channelsAllObj",
          CryptoJS.AES.encrypt(
            JSON.stringify(myArrayFiltered),
            process.env.REACT_APP_PASS
          ).toString()
        );
      }

      let cAllObj = this.decryptLocal("channelsAllObj");
      let optionsArray = [];
      for (let i in cAllObj) {
        if (cAllObj[i]["display"] == true) {
          let obj = {};
          obj["label"] = cAllObj[i]["program"];
          obj["value"] = cAllObj[i]["id"];
          optionsArray.push(obj);
        }
      }
      this.setState({ channelsDropDown: optionsArray });
    }

    this.setState({ channelModal: true });
    this.handleClose("typeModal");
  }

  setUpdatedChannelsDropdown(cT) {
    localStorage.setItem(
      "selectedCustomerType",
      CryptoJS.AES.encrypt(JSON.stringify(cT), process.env.REACT_APP_PASS).toString()
    );

    let completeChannelsArray = this.decryptLocal("channelsAllObj");
    let myArrayFiltered = [];
    if (cT === "Acquistion") {
      myArrayFiltered = completeChannelsArray.filter((el) => {
        return this.state.acquisitionChannelId.some((f) => {
          return f.id === el.id;
        });
      });

      localStorage.setItem(
        "channelsAllObj",
        CryptoJS.AES.encrypt(
          JSON.stringify(myArrayFiltered),
          process.env.REACT_APP_PASS
        ).toString()
      );
    } else if (cT === "Customer") {
      myArrayFiltered = completeChannelsArray.filter((el) => {
        return this.state.customerChannelId.some((f) => {
          return f.id === el.id;
        });
      });

      localStorage.setItem(
        "channelsAllObj",
        CryptoJS.AES.encrypt(
          JSON.stringify(myArrayFiltered),
          process.env.REACT_APP_PASS
        ).toString()
      );
    } else {
      myArrayFiltered = completeChannelsArray.filter((el) => {
        return this.state.combinedChannelId.some((f) => {
          return f.id === el.id;
        });
      });

      localStorage.setItem(
        "channelsAllObj",
        CryptoJS.AES.encrypt(
          JSON.stringify(myArrayFiltered),
          process.env.REACT_APP_PASS
        ).toString()
      );
    }

    let cAllObj = this.decryptLocal("channelsAllObj");
    let optionsArray = [];
    for (let i in cAllObj) {
      if (cAllObj[i]["display"] == true) {
        let obj = {};
        obj["label"] = cAllObj[i]["program"];
        obj["value"] = cAllObj[i]["id"];
        optionsArray.push(obj);
      }
    }
    this.setState({ channelsDropDown: optionsArray });
  }

  async setCustType(channelId) {
    localStorage.setItem(
      "activeChannel",
      CryptoJS.AES.encrypt(JSON.stringify(channelId), process.env.REACT_APP_PASS).toString()
    );

    if (
      this.state.localStorageClientId ===
      "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
      this.state.localStorageClientId ===
      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
      this.state.localStorageClientId ===
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
      this.state.localStorageClientId ===
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
      this.state.localStorageClientId ===
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
      this.state.localStorageClientId ===
      "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
      this.state.localStorageClientId ===
      "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
      this.state.localStorageClientId ===
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
      this.state.localStorageClientId ===
      "7abec586-17b8-4174-993d-e3d86648ed60" ||
      this.state.localStorageClientId ===
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
      this.state.localStorageClientId ===
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
      this.state.localStorageClientId ===
      "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
      this.state.localStorageClientId ===
      "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
      this.state.localStorageClientId ===
      "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
      this.state.localStorageClientId ===
      "acf275e9-3f68-4250-9f8a-e80672b133f3" ||
      this.state.localStorageClientId ===
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
      this.state.localStorageClientId ===
      "31a73952-d1bf-4647-af62-204b1f56596c" ||
      this.state.localStorageClientId ===
      "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
      this.state.localStorageClientId ===
      "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
      this.state.localStorageClientId ===
      "7203dd51-f88b-4a4b-877c-92326d027915" ||
      this.state.localStorageClientId ===
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
      this.state.localStorageClientId === 
      "874b6c6a-83ff-480b-b615-1972538813ba" ||
      this.state.localStorageClientId === 
      "b76e7818-deb1-4526-93a7-b398df3ea357" ||
      this.state.localStorageClientId === 
        "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
      this.state.localStorageClientId === 
        "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
      this.state.localStorageClientId === 
        "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
      this.state.localStorageClientId === 
        "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
      this.state.localStorageClientId === 
        "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
      this.state.localStorageClientId === 
        "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
      this.state.localStorageClientId === 
        "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
      this.state.localStorageClientId ===
        "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
      this.state.localStorageClientId ===
        "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
      this.state.localStorageClientId ===
        "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
    ) {
      if (
        channelId === "0417f699-bdd9-473d-873f-499e1c86efac" ||
        channelId === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
        channelId === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
      ) {
        if (
          this.state.localStorageClientId ===
          "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9"
        ) {
          localStorage.setItem(
            "globalFilter",
            CryptoJS.AES.encrypt(
              JSON.stringify("di.geo_concept = '1'"),
              process.env.REACT_APP_PASS
            ).toString()
          );
        } else {
          localStorage.setItem(
            "globalFilter",
            CryptoJS.AES.encrypt(
              JSON.stringify("di.geo_concept = '1'"),
              process.env.REACT_APP_PASS
            ).toString()
          );
        }
      } else {
        if (
          this.state.localStorageClientId ===
          "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9"
        ) {
          localStorage.setItem(
            "globalFilter",
            CryptoJS.AES.encrypt(
              JSON.stringify("ca.geo_concept = '1'"),
              process.env.REACT_APP_PASS
            ).toString()
          );
        } else {
          localStorage.setItem(
            "globalFilter",
            CryptoJS.AES.encrypt(
              JSON.stringify("ca.geo_concept = '1'"),
              process.env.REACT_APP_PASS
            ).toString()
          );
        }
      }
    }

    let defaultcust_tillSqlSelectionArr = [];
    let defaultcust_afterSqlSelectionArr = [];
    let defaultcust_groupLeveltoggle = [];
    let defaultcust_ruleLeveltoggle = [];

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    // if (
    //   this.state.localStorageClientId === "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
    // ) {
    //   defaultcust_tillSqlSelectionArr = [
    //     [
    //       [
    //         {
    //           label: "Lifecycle",
    //           value: "Lifecycle",
    //         },
    //         {
    //           label: "Post-Onboarding",
    //           value: "ca.member_tenure",
    //         },
    //         {
    //           label: "is equal to (==)",
    //           value: "=",
    //         },
    //       ],
    //     ],
    //   ];
    //   defaultcust_afterSqlSelectionArr = [
    //     [
    //       [
    //         {
    //           label: "Yes",
    //           value: true,
    //         },
    //       ],
    //     ],
    //   ];
    //   defaultcust_groupLeveltoggle = [];
    //   defaultcust_ruleLeveltoggle = [["AND"]];
    // } else {
    //   if (
    //     this.state.localStorageClientId ===
    //       "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //     JSON.parse(
    //       CryptoJS.AES.decrypt(
    //         localStorage.getItem("activeChannel"),
    //         process.env.REACT_APP_PASS
    //       ).toString(CryptoJS.enc.Utf8)
    //     ) === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
    //   ) {
    //     defaultcust_tillSqlSelectionArr = [
    //       [
    //         [
    //           {
    //             label: "Location",
    //             value: "Location",
    //           },
    //           {
    //             label: "Favorite Location/Store is Open",
    //             value: "geo.geo_active",
    //           },
    //           {
    //             label: "is equal to (==)",
    //             value: "=",
    //           },
    //         ],
    //         [
    //           {
    //             value: "Program",
    //             label: "Program",
    //           },
    //           {
    //             value: "Loyalty",
    //             label: "Loyalty",
    //           },
    //           {
    //             value:
    //               JSON.parse(
    //                 CryptoJS.AES.decrypt(
    //                   localStorage.getItem("activeChannel"),
    //                   process.env.REACT_APP_PASS
    //                 ).toString(CryptoJS.enc.Utf8)
    //               ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    //                 ? "oc.email_marketable"
    //                 : "lo.email_marketable",
    //             label: "Customer has Opted-out of Loyalty",
    //           },
    //           {
    //             value: "=",
    //             label: "is equal to (==)",
    //           },
    //         ],
    //       ],
    //     ];
    //     defaultcust_afterSqlSelectionArr = [
    //       [
    //         [
    //           {
    //             label: "Yes",
    //             value: true,
    //           },
    //         ],
    //         [
    //           {
    //             label: "No",
    //             value: true,
    //           },
    //         ],
    //       ],
    //     ];
    //     defaultcust_groupLeveltoggle = [];
    //     defaultcust_ruleLeveltoggle = [["AND"]];
    //   } else if (
    //     this.state.localStorageClientId ===
    //       "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
    //     JSON.parse(
    //       CryptoJS.AES.decrypt(
    //         localStorage.getItem("activeChannel"),
    //         process.env.REACT_APP_PASS
    //       ).toString(CryptoJS.enc.Utf8)
    //     ) === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
    //   ) {
    //     // Friday's OLO Channel
    //     defaultcust_tillSqlSelectionArr = [];
    //     defaultcust_afterSqlSelectionArr = [];
    //     defaultcust_groupLeveltoggle = [];
    //     defaultcust_ruleLeveltoggle = [];
    //   } else {
    //     defaultcust_tillSqlSelectionArr = [
    //       [
    //         [
    //           {
    //             label: "Relationship",
    //             value: "Relationship",
    //           },
    //           {
    //             label: "Active Customer Flag",
    //             value: "ca.cust_active",
    //           },
    //           {
    //             label: "is equal to (==)",
    //             value: "=",
    //           },
    //         ],
    //         [
    //           {
    //             label: "Location",
    //             value: "Location",
    //           },
    //           {
    //             label: "Favorite Location/Store is Open",
    //             value: "geo.geo_active",
    //           },
    //           {
    //             label: "is equal to (==)",
    //             value: "=",
    //           },
    //         ],
    //       ],
    //     ];
    //     defaultcust_afterSqlSelectionArr = [
    //       [
    //         [
    //           {
    //             label: "Yes",
    //             value: true,
    //           },
    //         ],
    //         [
    //           {
    //             label: "Yes",
    //             value: true,
    //           },
    //         ],
    //       ],
    //     ];
    //     defaultcust_groupLeveltoggle = [];
    //     defaultcust_ruleLeveltoggle = [["AND"]];
    //   }
    // }

    if (selectedCustomerType === "Customer") {
      if (
        this.state.localStorageClientId ===
        "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
      ) {
        if (
          this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
          this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
        ) {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        } else {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Post-Onboarding",
                  value: "Post-Onboarding",
                },
                {
                  label: "Post-Onboarding",
                  value: "ca.member_tenure",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        }
      } else {
        if (
          this.state.localStorageClientId ===
          "712cc8e9-3a79-4900-b122-ec9812e0f0ca" &&
          this.decryptLocal("activeChannel") === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
        ) {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  value: "Program",
                  label: "Program",
                },
                {
                  value: "Loyalty",
                  label: "Loyalty",
                },
                {
                  value:
                    this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
                      ? "oc.email_marketable"
                      : "lo.email_marketable",
                  label: "Customer has Opted-out of Loyalty",
                },
                {
                  value: "=",
                  label: "is equal to (==)",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "No",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        } else if (
          (this.state.localStorageClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca" && this.decryptLocal("activeChannel") === "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91")
          || (this.state.localStorageClientId === "e722fa14-9dbd-11ee-8c90-0242ac120002")
        ) {
          // Friday's OLO Channel && ToC
          defaultcust_tillSqlSelectionArr = [];
          defaultcust_afterSqlSelectionArr = [];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [];
        } else if (
          (this.state.localStorageClientId ===
            "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
            this.state.localStorageClientId ===
            "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
            this.state.localStorageClientId ===
            "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
            this.state.localStorageClientId ===
            "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
            this.state.localStorageClientId ===
            "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
            this.state.localStorageClientId ===
            "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
            this.state.localStorageClientId ===
            "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
            this.state.localStorageClientId ===
            "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
            this.state.localStorageClientId ===
            "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
            this.state.localStorageClientId ===
            "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
            this.state.localStorageClientId ===
            "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
            this.state.localStorageClientId ===
            "acf275e9-3f68-4250-9f8a-e80672b133f3" ||
            this.state.localStorageClientId ===
            "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
            this.state.localStorageClientId ===
            "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
            this.state.localStorageClientId ===
            "31a73952-d1bf-4647-af62-204b1f56596c" ||
            this.state.localStorageClientId ===
            "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
            this.state.localStorageClientId ===
            "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
            this.state.localStorageClientId ===
            "7203dd51-f88b-4a4b-877c-92326d027915" ||
            this.state.localStorageClientId ===
            "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId === 
            "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === 
            "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId === 
              "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
            this.state.localStorageClientId === 
              "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId === 
              "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
            this.state.localStorageClientId === 
              "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === 
              "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === 
              "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === 
              "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId ===
              "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId ===
              "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId ===
              "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
          (
            this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
            this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
          )
        ) {
          // Kahala Display
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [];
        }
        // Loyalty
        else if ((JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("activeChannel"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)) === 'f786cb0f-eecc-4b87-adef-34eb20f3f766' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === '88adbfaa-0fc0-49af-a745-d97cb1b4bda7' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === '3c8a9cf7-a0b2-4845-8436-d598181e6d78' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === '33bc71b1-4495-43f0-ab64-17ed38270e04'  
        ) && (
            this.state.localStorageClientId === '8c001fde-3728-48dc-9950-b8480ca9fbee' ||
            this.state.localStorageClientId === '3fe7e557-16f5-406c-bbc8-887fdec7ba8b' ||
            this.state.localStorageClientId === 'dc0df8ce-c87e-4746-a00e-d2c9ee4d7534' ||
            this.state.localStorageClientId === 'ec0df8ce-c87e-4746-a00e-d2c9ee4d7534' ||
            this.state.localStorageClientId === '535a90f3-b463-4d5a-9a83-39c522589a6c' ||
            this.state.localStorageClientId === "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
            this.state.localStorageClientId === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
            this.state.localStorageClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
            this.state.localStorageClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
            this.state.localStorageClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
            this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
          )) {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Relationship",
                  value: "Relationship",
                },
                {
                  label: "Active Customer Flag",
                  value: "ca.cust_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        }
        // ECLUB
        else if ((JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("activeChannel"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)) === '3b3e90db-f06b-4ba4-9fbb-769637647ab0' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === '92ec41c7-6724-4891-bc17-24981a3261dd' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === 'c2a842ba-36cc-46b7-8fa4-3a361708b34b' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === '25c7cb9a-a192-46f5-b32d-49e8d52afea8'
        ) && (
            this.state.localStorageClientId === '8c001fde-3728-48dc-9950-b8480ca9fbee' ||
            this.state.localStorageClientId === '3fe7e557-16f5-406c-bbc8-887fdec7ba8b' ||
            this.state.localStorageClientId === 'dc0df8ce-c87e-4746-a00e-d2c9ee4d7534' ||
            this.state.localStorageClientId === 'ec0df8ce-c87e-4746-a00e-d2c9ee4d7534' ||
            this.state.localStorageClientId === '535a90f3-b463-4d5a-9a83-39c522589a6c' ||
            this.state.localStorageClientId === "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
            this.state.localStorageClientId === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
            this.state.localStorageClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
            this.state.localStorageClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
            this.state.localStorageClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
            this.state.localStorageClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
            this.state.localStorageClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
            this.state.localStorageClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
            this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
            this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
            this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
            this.state.localStorageClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
            this.state.localStorageClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
            this.state.localStorageClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
            this.state.localStorageClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
            this.state.localStorageClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
          )) {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Relationship",
                  value: "Relationship",
                },
                {
                  label: "Active Customer Flag",
                  value: "ca.cust_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        }
        // DISPLAY
        else if ((
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === 'd1606aea-0c0d-4fba-83e8-a124f414a953' ||
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("activeChannel"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)) === 'a8f39ffb-24c5-432a-9bcd-e5d0166a320e'
        ) && (
            this.state.localStorageClientId === '7abec586-17b8-4174-993d-e3d86648ed60' ||
            this.state.localStorageClientId === '5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406' ||
            this.state.localStorageClientId === '2b7ed789-e2d0-45c0-a45f-49e27d736a7b' ||
            this.state.localStorageClientId === 'ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9'
          )) {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Relationship",
                  value: "Relationship",
                },
                {
                  label: "Active Customer Flag",
                  value: "ca.cust_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND"]];
        }
        // EMAIL
        else if (JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("activeChannel"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)) === '1905c46e-6f48-4ed8-b2a9-35dbbf3bae91') {
          defaultcust_tillSqlSelectionArr = [];
          defaultcust_afterSqlSelectionArr = [];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [];
        }
        // GUEST CONNECT
        else {
          defaultcust_tillSqlSelectionArr = [
            [
              [
                {
                  label: "Relationship",
                  value: "Relationship",
                },
                {
                  label: "Active Customer Flag",
                  value: "ca.cust_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location/Store is Open",
                  value: "geo.geo_active",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
              [
                {
                  label: "Location",
                  value: "Location",
                },
                {
                  label: "Favorite Location Participating in Guest Connect",
                  value: "geo.geo_preclub",
                },
                {
                  label: "is equal to (==)",
                  value: "=",
                },
              ],
            ],
          ];
          defaultcust_afterSqlSelectionArr = [
            [
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
              [
                {
                  label: "Yes",
                  value: true,
                },
              ],
            ],
          ];
          defaultcust_groupLeveltoggle = [];
          defaultcust_ruleLeveltoggle = [["AND", "AND"]];
        }
      }
      // PROSPECTING
    } else {
      // Audience Type : Prospect -> (Added two default filters -> Geo Active and Top 3 Model Deciles)
      defaultcust_tillSqlSelectionArr = [
        [
          [
            {
              label: "Location",
              value: "Location",
            },
            {
              label: "Favorite Location/Store is Open",
              value: "geo_active",
            },
            {
              label: "is equal to (==)",
              value: "=",
            },
          ],
          [
            {
              label: "Models",
              value: "Models",
            },
            {
              label: "Model Decile",
              value: "model_decile",
            },
            {
              label: "any in",
              value: "IN",
            },
          ],
        ],
      ];
      defaultcust_afterSqlSelectionArr = [
        [
          [
            {
              label: "Yes",
              value: true,
            },
          ],
          [
            {
              label: " Decile - 1 (Good)",
              value: "1",
            },
            {
              label: " Decile - 2",
              value: "2",
            },
            {
              label: " Decile - 3",
              value: "3",
            },
          ],
        ],
      ];
      defaultcust_groupLeveltoggle = [];
      defaultcust_ruleLeveltoggle = [["AND"]];
    }

    if (
      this.decryptLocal("model") == "restaurant_v2"
    ) {
      defaultcust_tillSqlSelectionArr = [
        [
          [
            {
              label: "Relationship",
              value: "Relationship",
            },
            {
              label: "Active Customer Flag",
              value: "ca.cust_active",
            },
            {
              label: "is equal to (==)",
              value: "=",
            },
          ],
          [
            {
              label: "Location",
              value: "Location",
            },
            {
              label: "Favorite Location Participating in Guest Connect",
              value: "geo.geo_preclub",
            },
            {
              label: "is equal to (==)",
              value: "=",
            },
          ],
        ],
      ];
    }

    // Apply Channel Specific Rules
    let channelFiltersObj = this.decryptLocal("channelsAllObj").filter((obj) => obj.id === channelId)[0]["channelFilters"];
    for (let eachcust_tillSqlSelectionArr in channelFiltersObj[
      "cust_tillSqlSelectionArr"
    ]) {
      defaultcust_tillSqlSelectionArr.push(
        channelFiltersObj["cust_tillSqlSelectionArr"][
        eachcust_tillSqlSelectionArr
        ]
      );
    }
    for (let eachcust_afterSqlSelectionArr in channelFiltersObj[
      "cust_afterSqlSelectionArr"
    ]) {
      defaultcust_afterSqlSelectionArr.push(
        channelFiltersObj["cust_afterSqlSelectionArr"][
        eachcust_afterSqlSelectionArr
        ]
      );
    }
    for (let eachcust_groupLeveltoggle in channelFiltersObj[
      "cust_groupLeveltoggle"
    ]) {
      defaultcust_groupLeveltoggle.push(
        channelFiltersObj["cust_groupLeveltoggle"][eachcust_groupLeveltoggle]
      );
    }
    for (let eachcust_ruleLeveltoggle in channelFiltersObj[
      "cust_ruleLeveltoggle"
    ]) {
      defaultcust_ruleLeveltoggle.push(
        channelFiltersObj["cust_ruleLeveltoggle"][eachcust_ruleLeveltoggle]
      );
    }

    // CUSTOM OVERRIDE - ECLUB
    // LOUS
    // KAHALA
    // PLANET SMOOTHIE
    if (
      (
        this.state.localStorageClientId === "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        this.state.localStorageClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.state.localStorageClientId === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.state.localStorageClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.state.localStorageClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.state.localStorageClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.state.localStorageClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.state.localStorageClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.state.localStorageClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.state.localStorageClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.state.localStorageClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.state.localStorageClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.state.localStorageClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.state.localStorageClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        this.state.localStorageClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
      )
      &&
      (
        this.decryptLocal("activeChannel") === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
        this.decryptLocal("activeChannel") === "c2a842ba-36cc-46b7-8fa4-3a361708b34b" ||
        this.decryptLocal("activeChannel") === "25c7cb9a-a192-46f5-b32d-49e8d52afea8"
      )
    ) {
      defaultcust_tillSqlSelectionArr = [
        [
          [
            {
              "label": "Program",
              "value": "Program"
            },
            {
              "label": "Eclub",
              "value": "Eclub"
            },
            {
              "label": "Customer is member of Eclub",
              "value": "ca.eclub"
            },
            {
              "label": "is equal to (==)",
              "value": "="
            }
          ],
          [
            {
              "label": "Program",
              "value": "Program"
            },
            {
              "label": "Loyalty",
              "value": "Loyalty"
            },
            {
              "label": "Customer is member of Loyalty",
              "value": "ca.loyalty"
            },
            {
              "label": "is equal to (==)",
              "value": "="
            }
          ]
        ]
      ];
      defaultcust_afterSqlSelectionArr = [
        [
          [
            {
              "label": "Yes",
              "value": true
            }
          ],
          [
            {
              "label": "No",
              "value": false
            }
          ]
        ]
      ];
      defaultcust_groupLeveltoggle = [];
      defaultcust_ruleLeveltoggle = [
        [
          "AND"
        ]
      ];
    }
    // CUSTOM OVERRIDE - LOYALTY
    // LOUS
    // KAHALA
    // PLANETSMOOTHIE
    else if (
      (
        this.state.localStorageClientId === "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        this.state.localStorageClientId === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.state.localStorageClientId === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.state.localStorageClientId === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.state.localStorageClientId === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.state.localStorageClientId === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.state.localStorageClientId === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.state.localStorageClientId === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.state.localStorageClientId === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.state.localStorageClientId === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.state.localStorageClientId === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.state.localStorageClientId === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.state.localStorageClientId === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.state.localStorageClientId === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        this.state.localStorageClientId === "535a90f3-b463-4d5a-9a83-39c522589a6c"
      )
      &&
      (
        this.decryptLocal("activeChannel") === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
        this.decryptLocal("activeChannel") === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" ||
        this.decryptLocal("activeChannel") === "1d337d2d-e23a-445a-bda6-2405dbb79dcc" ||
        this.decryptLocal("activeChannel") === "33bc71b1-4495-43f0-ab64-17ed38270e04" ||
        this.decryptLocal("activeChannel") === "3c8a9cf7-a0b2-4845-8436-d598181e6d78" ||
        this.decryptLocal("activeChannel") === "g786cb0f-eecc-4b87-adef-34eb20f3f766"
      )
    ) {
      defaultcust_tillSqlSelectionArr = [
        [
          [
            {
              "label": "Program",
              "value": "Program"
            },
            {
              "label": "Loyalty",
              "value": "Loyalty"
            },
            {
              "label": "Customer is member of Loyalty",
              "value": "ca.loyalty"
            },
            {
              "label": "is equal to (==)",
              "value": "="
            }
          ],
        ]
      ];
      defaultcust_afterSqlSelectionArr = [
        [
          [
            {
              "label": "Yes",
              "value": true
            }
          ]
        ]
      ];
      defaultcust_groupLeveltoggle = [];
      defaultcust_ruleLeveltoggle = [[
      ]];
    }

    this.setState({ isLoading: false });
    this.props.dispatch({
      type: "EDIT_AUDIENCE",
      tillSqlSelectionArr: "",
      afterSqlSelectionArr: "",
      groupLeveltoggle: "",
      ruleLeveltoggle: "",
    });
    this.props.dispatch({
      type: "EDIT_AUDIENCE_SEGMENT",
      tillSqlSelectionArrSegment: "",
      afterSqlSelectionArrSegment: "",
      groupLeveltoggleSegment: "",
      ruleLeveltoggleSegment: "",
      segmentName: [],
    });
    this.props.dispatch({
      type: "CUST_EDIT_AUDIENCE",
      cust_tillSqlSelectionArr: defaultcust_tillSqlSelectionArr, //bSqlSelectionArr
      cust_afterSqlSelectionArr: defaultcust_afterSqlSelectionArr, //aSqlSelectionArr
      cust_groupLeveltoggle: defaultcust_groupLeveltoggle, //groupLeveltoggle
      cust_ruleLeveltoggle: defaultcust_ruleLeveltoggle, // ruleLeveltoggle
    });
    this.props.dispatch({
      type: "CUST_EDIT_AUDIENCE_SEGMENT",
      cust_tillSqlSelectionArrSegment: "",
      cust_afterSqlSelectionArrSegment: "",
      cust_groupLeveltoggleSegment: "",
      cust_ruleLeveltoggleSegment: "",
      cust_segmentName: [],
    });
    if (this.state.customerType === "Acquistion") {
      this.setState({
        showAcquistion: true,
        defaultIndex: 0,
        isAcquistionClicked: true,
      });
    } else if (this.state.customerType === "Eclub") {
      await this.setState({
        showEclub: true,
        defaultIndex: 1,
      });
    } else {
      await this.setState({
        showCustomerConnect: true,
        defaultIndex: 2,
        isCustomerClicked: true,
      });
    }
    this.handleClose("channelModal");
  }

  getSegmentCondition() {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.props.cust_groupLeveltoggleSegment;
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    let automationIdOrListId = "";
    let automationIdOrListIdExists = false;
    let menuItemsSelected = false;
    let menuSubCategorySelected = false;

    this.props.cust_tillSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.props.cust_segmentName[index] != undefined) {
        segment = this.props.cust_segmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        if (options.find((test) => test.value === "li.list_id") !== undefined) {
          // alert("Create Audience Exists");
          automationIdOrListIdExists = true;
        } else {
          automationIdOrListIdExists = false;
          // alert("Create Audience Undefined");
        }
        if (
          options.find(
            (menuItem) =>
              menuItem.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuItemBajaFresh) =>
              menuItemBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuSubCategory) =>
              menuSubCategory.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find(
            (menuSubCategoryBajaFresh) =>
              menuSubCategoryBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id in (select item_id from bajafresh_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        let length = options.length;
        if (
          "value" in options[length - 2] &&
          options[length - 2].value.includes("+++")
        ) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }
        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
        }
        let data = this.props.cust_afterSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  // alert("Value Exists If block CA");
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                // selectedRule += `))`;
                if (menuItemsSelected) {
                  selectedRule += `))))`;
                } else if (menuSubCategorySelected) {
                  selectedRule += `)))))`;
                } else {
                  selectedRule += `))`;
                }
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  // alert("Value Exists Else Block CA");
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${this.decryptLocal("globalFilter")})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (options[length - 1].value == "= ") {
              selectedRule += ` ${result.value} AND ${this.decryptLocal("globalFilter")})`;
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND ${this.decryptLocal("globalFilter")}),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}'), `;
              } else {
                selectedRule += ` ${result.value}), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      // selectedRule += `)`;
      // sqlAndOrOperator = "";
      // if (
      //   groupLeveltoggle.length > 0 &&
      //   this.props.cust_tillSqlSelectionArrSegment.length - 1 != index &&
      //   groupLeveltoggle[0] != undefined &&
      //   groupLeveltoggle[0][index] != undefined
      // ) {
      //   sqlAndOrOperator = groupLeveltoggle[0][index];
      //   selectedRule += ` ${sqlAndOrOperator} `;
      // }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");

      // selectedRule = selectedRule.replaceAll(
      //   "ca.segment",
      //   "CAST(ca.segment AS varchar)"
      // );

      selectedRule = selectedRule.replaceAll("lo.loyalty_birthday = ", "");
      selectedRule = selectedRule.replaceAll("lo.loyalty_half_birthday = ", "");

      for (let i = 1; i <= 12; i++) {
        var firstIndex = selectedRule.indexOf(
          `'if(month(date(lo.loyalty_birthday)) = ${i},true)'`
        );
        if (firstIndex !== -1) {
          var lastIndex = firstIndex + 46;
          if (i >= 10) {
            lastIndex = firstIndex + 47;
          }
          var whatIHave =
            selectedRule.slice(0, firstIndex) +
            `if(month(date(lo.loyalty_birthday)) = ${i},true)` +
            selectedRule.slice(lastIndex + 1);
          selectedRule = whatIHave;
        }
      }

      for (let i = 1; i <= 12; i++) {
        var firstIndex = selectedRule.indexOf(
          `'if(month(date(lo.loyalty_half_birthday)) = ${i},true)'`
        );
        if (firstIndex !== -1) {
          var lastIndex = firstIndex + 51;
          if (i >= 10) {
            lastIndex = firstIndex + 52;
          }
          var whatIHave =
            selectedRule.slice(0, firstIndex) +
            `if(month(date(lo.loyalty_half_birthday)) = ${i},true)` +
            selectedRule.slice(lastIndex + 1);
          selectedRule = whatIHave;
        }
      }

      // Delivery File Suppression Changes
      if (automationIdOrListId !== null) {
        if (
          this.decryptLocal("model") === "restaurant_v3"
        ) {
          let currDb = this.decryptLocal("custDb")

          // IN
          let currRegex = / *li\.list_id +IN *\((.*?)\)/g;
          let currMatch = (' ' + selectedRule).slice(1).match(currRegex);
          let singleRegex, currAutomation
          if (currMatch) {
            let singleRegex = / *li\.list_id +IN *\((.*?)\)/;
            for (let idx in currMatch) {
              currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
              selectedRule = selectedRule.replace(
                singleRegex,
                // Replace With
                "ca.cust_id IN" +
                "(" +
                "SELECT cust_id from " +
                currDb + ".deliveries where delivery_id IN " +
                "(" +
                "select delivery_id " +
                "from " + currDb + ".cmp_deliveries " +
                "where automation_id in (" + currAutomation[1] + ")" +
                ")" +
                ")"
              );
            }
          }

          // NOT IN
          currRegex = / *li\.list_id +NOT +IN *\((.*?)\)/g;
          currMatch = (' ' + selectedRule).slice(1).match(currRegex);
          if (currMatch) {
            singleRegex = / *li\.list_id +NOT +IN *\((.*?)\)/;
            for (let idx in currMatch) {
              currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
              selectedRule = selectedRule.replace(
                singleRegex,
                // Replace With
                "ca.cust_id NOT IN" +
                "(" +
                "SELECT cust_id from " +
                currDb + ".deliveries where delivery_id IN " +
                "(" +
                "select delivery_id " +
                "from " + currDb + ".cmp_deliveries " +
                "where automation_id in (" + currAutomation[1] + ")" +
                ")" +
                ")"
              );
            }
          }
        }
      }

      // Goodwill Reward Expiration Filter Changes
      selectedRule = selectedRule.replaceAll(
        "ca.member_tenure = true",
        "(ca.member_tenure >= 90 or ca.trans_ltd > 1)"
      );

      selectedRule = selectedRule.replaceAll(
        "ca.member_tenure = false",
        "(ca.member_tenure < 90 and ca.trans_ltd <= 1)"
      );

      selectedRule = selectedRule.replaceAll(
        "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 14",
        "ca.member_tenure = 14"
      );

      selectedRule = selectedRule.replaceAll(
        "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 7",
        "ca.member_tenure = 7"
      );

      selectedRule = selectedRule.replaceAll(
        "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 0",
        "ca.member_tenure = 0"
      );

      let originaltext = selectedRule;
      let test = originaltext
        .split(
          "(ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = "
        )
        .pop();
      let final = test.replace(")", "");
      let test1 = final
        .replaceAll("'", "")
        .split("THEN")[0]
        .split("AND")[0];
      let test2 = final
        .replaceAll("'", "")
        .split("THEN")[0]
        .split("AND")[1];

      if (test1 !== "" && test1 !== undefined) {
        test1 = test1.trim();
      }

      if (test2 !== "" && test2 !== undefined) {
        test2 = test2.trim();
      }

      if (test1 !== null && test2 !== null) {
        // alert("Offer Code CA Segment is :" + test1);
        // alert("Offer Code Duration CA Segment is :" + test2);
        selectedRule = selectedRule.replace(
          `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
          `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',${test2},current_date) AND orig_template_id = '${test1}'))`
        );
      }

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '26'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '26')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '22'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '22')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '265'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '265')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '293'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '293')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '6'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '6')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '400'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '400')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '32'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '32')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '266'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '266')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '20'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '20')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '244'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '244')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '251'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '251')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '33'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '33')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '312'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '312')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '36'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '36')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '35'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '35')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '250'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '250')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '277'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '277')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '27'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '27')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '268'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '268')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '252'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '252')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '10'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '10')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '285'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '285')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '2'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '2')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '248'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '248')))))"
      );

      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '323'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '323')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '888'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '888')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '242'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '242')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '245'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '245')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '267'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '267')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '249'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '249')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '27' and item_hier_2 = '23'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '27' and item_hier_2 = '23')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '278'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '278')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '19'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '19')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '348'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '348')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '31'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '31')))))"
      );
      selectedRule = selectedRule.replace(
        "(menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '269'')",
        "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '269')))))"
      );

      // Friday's Redemption Filter Changes

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '30' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '60' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '90' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '180' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '365' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day))"
      );

      // Friday's Discount Sales Filter changes

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '30' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '60' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '90' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '180' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = false)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '365' day))"
      );

      selectedRule = selectedRule.replace(
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = true)",
        "(ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day))"
      );

      // Goodwill Reward Expiration Filter Changes
      this.setState({ segRule: selectedRule });
    });
  }

  getWhereForSave() {
    let ruleLeveltoggle = this.props.cust_ruleLeveltoggle;
    let groupLeveltoggle = this.props.cust_groupLeveltoggle;
    let tillSqlSelectionArr = this.props.cust_tillSqlSelectionArr;
    let afterSqlSelectionArr = this.props.cust_afterSqlSelectionArr;

    let selectedRule = "";
    let prospectFilterRule = "";
    let customerFilterRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let count = 0;
    let sqlAndOrOperator = "";
    let automationIdOrListId = "";
    let automationIdOrListIdExists = false;
    let prospectConditionExists = false;
    let menuItemsSelected = false;
    let menuSubCategorySelected = false;

    let modelDecileConditionExists = false;
    let modelDecileSelectedRule = "";
    let nonModelDecileSelectedRule = "";
    let samplingConditionExists = false;
    let samplingSelectedRule = "";

    tillSqlSelectionArr.map((resultData, index) => {
      selectedRule += `(`;
      resultData.map((options, key) => {
        if (options.find((test) => test.value === "li.list_id") !== undefined) {
          automationIdOrListIdExists = true;
        } else {
          automationIdOrListIdExists = false;
        }
        if (options.find((test) => test.value.includes("hh.")) !== undefined) {
          prospectConditionExists = true;
        } else {
          prospectConditionExists = false;
        }
        if (
          options.find(
            (menuItem) =>
              menuItem.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (
          options.find(
            (menuItemBajaFresh) =>
              menuItemBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id"
          ) !== undefined
        ) {
          menuItemsSelected = true;
        } else {
          menuItemsSelected = false;
        }

        if (prospectConditionExists) {
          prospectFilterRule += `(`;
        } else {
          customerFilterRule += `(`;
        }

        if (
          options.find(
            (menuSubCategory) =>
              menuSubCategory.value ===
              "ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find(
            (menuSubCategoryBajaFresh) =>
              menuSubCategoryBajaFresh.value ===
              "ca.cust_id in (select cust_id from bajafresh_refined.trans_pay where trans_id in (select trans_id from bajafresh_refined.trans_detail where item_id in (select item_id from bajafresh_refined.item where concat(item_hier_1, '-', item_hier_2)"
          ) !== undefined
        ) {
          menuSubCategorySelected = true;
        } else {
          menuSubCategorySelected = false;
        }

        if (
          options.find((test) => test.value.includes("model_decile")) !==
          undefined
        ) {
          modelDecileConditionExists = true;
        } else {
          modelDecileConditionExists = false;
        }

        if (
          options.find((rule) => rule.value.includes("Sampling")) !== undefined
        ) {
          samplingConditionExists = true;
        } else {
          samplingConditionExists = false;
        }

        let length = options.length;
        if (options[length - 2].value.includes("+++")) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
          if (modelDecileConditionExists) {
            modelDecileSelectedRule += "(";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule += "(";
          }

          if (samplingConditionExists) {
            samplingSelectedRule += "(";
          }
        }
        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";

          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          }
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;

          if (modelDecileConditionExists) {
            modelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          } else if (!modelDecileConditionExists && !samplingConditionExists) {
            nonModelDecileSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }

          if (samplingConditionExists) {
            samplingSelectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }
        }
        let data = afterSqlSelectionArr[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `(`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `(`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `(`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }
                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }
                // selectedRule += `) AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )} )`;

                // if (menuItemsSelected) {
                //   selectedRule += `))) AND ${JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("globalFilter"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   )} )`;
                // } else if (menuSubCategorySelected) {
                //   selectedRule += `)))) AND ${JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("globalFilter"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   )} )`;

                //   if (modelDecileConditionExists) {
                //     modelDecileSelectedRule += `) ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : "AND"
                //     } ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : JSON.parse(
                //             CryptoJS.AES.decrypt(
                //               localStorage.getItem("globalFilter"),
                //               process.env.REACT_APP_PASS
                //             ).toString(CryptoJS.enc.Utf8)
                //           )
                //     } )`;
                //   } else {
                //     nonModelDecileSelectedRule += `) ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : "AND"
                //     } ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : JSON.parse(
                //             CryptoJS.AES.decrypt(
                //               localStorage.getItem("globalFilter"),
                //               process.env.REACT_APP_PASS
                //             ).toString(CryptoJS.enc.Utf8)
                //           )
                //     } )`;
                //   }
                // } else {
                //   selectedRule += `) AND ${JSON.parse(
                //     CryptoJS.AES.decrypt(
                //       localStorage.getItem("globalFilter"),
                //       process.env.REACT_APP_PASS
                //     ).toString(CryptoJS.enc.Utf8)
                //   )} )`;

                //   if (modelDecileConditionExists) {
                //     modelDecileSelectedRule += `) ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : "AND"
                //     } ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : JSON.parse(
                //             CryptoJS.AES.decrypt(
                //               localStorage.getItem("globalFilter"),
                //               process.env.REACT_APP_PASS
                //             ).toString(CryptoJS.enc.Utf8)
                //           )
                //     } )`;
                //   } else {
                //     nonModelDecileSelectedRule += `) ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : "AND"
                //     } ${
                //       JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Acquistion" ||
                //       (JSON.parse(
                //         CryptoJS.AES.decrypt(
                //           localStorage.getItem("selectedCustomerType"),
                //           process.env.REACT_APP_PASS
                //         ).toString(CryptoJS.enc.Utf8)
                //       ) === "Combined" &&
                //         prospectConditionExists)
                //         ? ""
                //         : JSON.parse(
                //             CryptoJS.AES.decrypt(
                //               localStorage.getItem("globalFilter"),
                //               process.env.REACT_APP_PASS
                //             ).toString(CryptoJS.enc.Utf8)
                //           )
                //     } )`;
                //   }
                // }

                if (menuItemsSelected) {
                  selectedRule += `))) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    } )`;
                } else if (menuSubCategorySelected) {
                  selectedRule += `)))) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    } )`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  }
                } else {
                  selectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    } )`;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += `) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : "AND"
                      } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                        (this.decryptLocal("selectedCustomerType") === "Combined" &&
                          prospectConditionExists)
                        ? ""
                        : this.decryptLocal("globalFilter")
                      } )`;
                  }
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== null &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                if (automationIdOrListIdExists) {
                  automationIdOrListId = num;
                }
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` '${result.value}', `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` '${result.value}', `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` '${result.value}', `;
                  }
                } else {
                  selectedRule += ` ${result.value}, `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${result.value}, `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${result.value}, `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${result.value}, `;
                  }
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }

                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                // selectedRule += `])) > 0 AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )})`;

                selectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : this.decryptLocal("globalFilter")
                  })`;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;

                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `[`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `[`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `[`;
                }
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule = modelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                if (samplingConditionExists) {
                  samplingSelectedRule = samplingSelectedRule.replace(
                    /,(\s+)?$/,
                    ""
                  );
                }

                // selectedRule += `])) > 0 AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )})`;

                selectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : this.decryptLocal("globalFilter")
                  })`;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += `])) > 0 ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    })`;
                }

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                  if (modelDecileConditionExists) {
                    modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  } else if (
                    !modelDecileConditionExists &&
                    !samplingConditionExists
                  ) {
                    nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                  }

                  if (samplingConditionExists) {
                    samplingSelectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}', `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}', `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}', `;
                }
              }
            } else if (options[length - 1].value == "= ") {
              // selectedRule += ` ${result.value} AND ${JSON.parse(
              //   CryptoJS.AES.decrypt(
              //     localStorage.getItem("globalFilter"),
              //     process.env.REACT_APP_PASS
              //   ).toString(CryptoJS.enc.Utf8)
              // )})`;

              selectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                (this.decryptLocal("selectedCustomerType") === "Combined" &&
                  prospectConditionExists)
                ? ""
                : "AND"
                } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : this.decryptLocal("globalFilter")
                })`;

              if (modelDecileConditionExists) {
                modelDecileSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                  })`;
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                  })`;
              }

              if (samplingConditionExists) {
                samplingSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  this.decryptLocal("selectedCustomerType") === "Combined"
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    this.decryptLocal("selectedCustomerType") === "Combined"
                    ? ""
                    : this.decryptLocal("globalFilter")
                  })`;
              }
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                // selectedRule += ` ${result.value}) AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )} ),`;

                selectedRule += ` ${result.value}) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : this.decryptLocal("globalFilter")
                  } ),`;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value}) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value}) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value}) ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }
              } else if (typeof num == "string") {
                // selectedRule += ` '${result.value}' AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )} ),`;

                selectedRule += ` '${result.value}' ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : this.decryptLocal("globalFilter")
                  } ),`;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` '${result.value}' ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` '${result.value}' ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` '${result.value}' ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }
              } else {
                // selectedRule += ` ${result.value} AND ${JSON.parse(
                //   CryptoJS.AES.decrypt(
                //     localStorage.getItem("globalFilter"),
                //     process.env.REACT_APP_PASS
                //   ).toString(CryptoJS.enc.Utf8)
                // )} ),`;

                selectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                  (this.decryptLocal("selectedCustomerType") === "Combined" &&
                    prospectConditionExists)
                  ? ""
                  : "AND"
                  } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : this.decryptLocal("globalFilter")
                  } ),`;

                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${result.value} ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                    (this.decryptLocal("selectedCustomerType") === "Combined" &&
                      prospectConditionExists)
                    ? ""
                    : "AND"
                    } ${this.decryptLocal("selectedCustomerType") === "Acquistion" ||
                      (this.decryptLocal("selectedCustomerType") === "Combined" &&
                        prospectConditionExists)
                      ? ""
                      : this.decryptLocal("globalFilter")
                    }),`;
                }
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (modelDecileConditionExists) {
                modelDecileSelectedRule = modelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              } else if (
                !modelDecileConditionExists &&
                !samplingConditionExists
              ) {
                nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }
              if (samplingConditionExists) {
                samplingSelectedRule = samplingSelectedRule.replace(
                  /,(\s+)?$/,
                  ""
                );
              }
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
                if (modelDecileConditionExists) {
                  modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                } else if (
                  !modelDecileConditionExists &&
                  !samplingConditionExists
                ) {
                  nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
                }

                if (samplingConditionExists) {
                  samplingSelectedRule += ` ${sqlAndOrOperator} `;
                }
              }
            }
          });
        }
      });
      selectedRule += `)`;
      var position = selectedRule.indexOf(")(") + 1;
      while (position > 0) {
        if (position > 0) {
          selectedRule = [
            selectedRule.slice(0, position),
            " AND ",
            selectedRule.slice(position),
          ].join("");
        }
        position = selectedRule.indexOf(")(") + 1;
      }
      sqlAndOrOperator = "";
      if (
        groupLeveltoggle.length > 0 &&
        tillSqlSelectionArr.length - 1 != index &&
        groupLeveltoggle[0] != undefined &&
        groupLeveltoggle[0][index] != undefined
      ) {
        sqlAndOrOperator = groupLeveltoggle[0][index];
        selectedRule += ` ${sqlAndOrOperator} `;
        if (modelDecileConditionExists) {
          modelDecileSelectedRule += ` ${sqlAndOrOperator} `;
        } else if (!modelDecileConditionExists && !samplingConditionExists) {
          nonModelDecileSelectedRule += ` ${sqlAndOrOperator} `;
        }

        if (samplingConditionExists) {
          samplingSelectedRule += ` ${sqlAndOrOperator} `;
        }
      }
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      if (modelDecileConditionExists) {
        modelDecileSelectedRule = modelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      } else if (!modelDecileConditionExists && !samplingConditionExists) {
        nonModelDecileSelectedRule = nonModelDecileSelectedRule.replace(
          /,(\s+)?$/,
          ""
        );
      }

      if (samplingConditionExists) {
        samplingSelectedRule = samplingSelectedRule.replace(/,(\s+)?$/, "");
      }
    });

    // selectedRule = selectedRule.replaceAll(
    //   "ca.segment",
    //   "CAST(ca.segment AS varchar)"
    // );
    selectedRule = selectedRule.replaceAll("lo.loyalty_birthday = ", "");
    selectedRule = selectedRule.replaceAll("lo.loyalty_half_birthday = ", "");

    for (let i = 1; i <= 12; i++) {
      var firstIndex = selectedRule.indexOf(
        `'if(month(date(lo.loyalty_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 46;
        if (i >= 10) {
          lastIndex = firstIndex + 47;
        }
        var whatIHave =
          selectedRule.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_birthday)) = ${i},true)` +
          selectedRule.slice(lastIndex + 1);
        selectedRule = whatIHave;
      }
    }

    for (let i = 1; i <= 12; i++) {
      var firstIndex = selectedRule.indexOf(
        `'if(month(date(lo.loyalty_half_birthday)) = ${i},true)'`
      );
      if (firstIndex !== -1) {
        var lastIndex = firstIndex + 51;
        if (i >= 10) {
          lastIndex = firstIndex + 52;
        }
        var whatIHave =
          selectedRule.slice(0, firstIndex) +
          `if(month(date(lo.loyalty_half_birthday)) = ${i},true)` +
          selectedRule.slice(lastIndex + 1);
        selectedRule = whatIHave;
      }
    }

    selectedRule = selectedRule.replaceAll(
      "ca.member_tenure = true",
      "(ca.member_tenure >= 90 or ca.trans_ltd > 1)"
    );

    selectedRule = selectedRule.replaceAll(
      "ca.member_tenure = false",
      "(ca.member_tenure < 90 and ca.trans_ltd <= 1)"
    );

    selectedRule = selectedRule.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 14",
      "ca.member_tenure = 14"
    );

    selectedRule = selectedRule.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 7",
      "ca.member_tenure = 7"
    );

    selectedRule = selectedRule.replaceAll(
      "(ca.trans_ltd in (0,1) or ca.trans_ltd is null) AND ca.member_tenure = 0",
      "ca.member_tenure = 0"
    );

    let originaltext = selectedRule;
    let test = originaltext
      .split(
        "((ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = "
      )
      .pop();
    let final = test.replace("AND ca.geo_concept = '1'))", "");
    let test1 = final.replaceAll("'", "").split("AND")[0];
    let test2 = final.replaceAll("'", "").split("AND")[1];

    if (test1 !== "" && test1 !== undefined) {
      test1 = test1.trim();
    }

    if (test2 !== "" && test2 !== undefined) {
      test2 = test2.trim();
    }

    if (test1 !== null && test2 !== null) {
      selectedRule = selectedRule.replace(
        // `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',{daysFromExpiration},current_date) AND orig_template_id = '{offerCode}')) = '${test1} AND ${test2}'`,
        `ca.cust_id IN (select cust_id from goodwill_refined.loyalty where loyalty_id IN(select customer_id from goodwill_source.tb_coupon where coupon_id NOT IN (select coupon_id from goodwill_source.tb_coupon_used) AND date(date_parse(act_date, '%c/%e/%Y %r')) <= current_date AND date(date_parse(deact_time, '%c/%e/%Y %r')) = date_add('day',${test2},current_date) AND orig_template_id = '${test1}'))`
      );
      selectedRule = selectedRule.replace(
        `= '${test1} AND ${test2}' AND ca.geo_concept = '1'`,
        "AND ca.geo_concept = '1'"
      );
    }

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '26'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '26'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '22'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '22'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '265'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '265'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '293'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '293'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '6'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '6'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '400'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '400'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '32'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '32'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '266'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '266'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '20'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '20'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '244'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '244'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '251'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '251'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '33'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '33'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '312'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '312'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '36'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '36'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '35'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '35'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '250'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '250'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '277'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '277'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '27'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '27'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '268'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '268'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '252'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '252'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '10'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '10'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '285'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '285'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '2'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '2'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '248'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '248'))) AND ca.geo_concept = '1'))"
    );

    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '323'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '323'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '888'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '888'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '242'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '242'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '245'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '245'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '18' and item_hier_2 = '267'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '18' and item_hier_2 = '267'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '249'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '249'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '27' and item_hier_2 = '23'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '27' and item_hier_2 = '23'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '278'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '278'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '19'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '19'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '38' and item_hier_2 = '16'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '38' and item_hier_2 = '16'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '348'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '348'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '1'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '1'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '13' and item_hier_2 = '31'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '13' and item_hier_2 = '31'))) AND ca.geo_concept = '1'))"
    );
    selectedRule = selectedRule.replace(
      "((menu_sub_category = 'item_hier_1 = '5' and item_hier_2 = '269'' AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select cust_id from fridays_refined.trans_pay where trans_id in (select trans_id from fridays_refined.trans_detail where item_id in (select item_id from fridays_refined.item where item_hier_1 = '5' and item_hier_2 = '269'))) AND ca.geo_concept = '1'))"
    );

    // Friday's Redemption Filter Changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent = 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.loyalty_checkins where points_spent > 0 and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1' ))"
    );

    // Friday's Discount Sales Filter changes

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '30' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '60' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '90' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '180' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = false AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt = 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1' ))"
    );

    selectedRule = selectedRule.replace(
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) = true AND ca.geo_concept = '1' ))",
      "((ca.cust_id in (select distinct cust_id from fridays_refined.trans_pay where pay_disc_amt > 0 and cust_id is not null and trans_dt >= current_date - interval '365' day) AND ca.geo_concept = '1' ))"
    );

    // Delivery File Suppression Changes:
    if (automationIdOrListId !== null) {
      if (
        this.decryptLocal("model") === "restaurant_v3"
      ) {
        let currDb = this.decryptLocal("custDb")

        // IN
        let currRegex = / *li\.list_id +IN *\((.*?)\)/g;
        let currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        let singleRegex, currAutomation
        if (currMatch) {
          let singleRegex = / *li\.list_id +IN *\((.*?)\)/;
          for (let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "ca.cust_id IN" +
              "(" +
              "SELECT cust_id from " +
              currDb + ".deliveries where delivery_id IN " +
              "(" +
              "select delivery_id " +
              "from " + currDb + ".cmp_deliveries " +
              "where automation_id in (" + currAutomation[1] + ")" +
              ")" +
              ")"
            );
          }
        }

        // NOT IN
        currRegex = / *li\.list_id +NOT +IN *\((.*?)\)/g;
        currMatch = (' ' + selectedRule).slice(1).match(currRegex);
        if (currMatch) {
          singleRegex = / *li\.list_id +NOT +IN *\((.*?)\)/;
          for (let idx in currMatch) {
            currAutomation = (' ' + currMatch[idx]).slice(1).match(singleRegex)
            selectedRule = selectedRule.replace(
              singleRegex,
              // Replace With
              "ca.cust_id NOT IN" +
              "(" +
              "SELECT cust_id from " +
              currDb + ".deliveries where delivery_id IN " +
              "(" +
              "select delivery_id " +
              "from " + currDb + ".cmp_deliveries " +
              "where automation_id in (" + currAutomation[1] + ")" +
              ")" +
              ")"
            );
          }
        }
      }
    }

    if (
      (this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
        this.decryptLocal("clientId") === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
        this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
        this.decryptLocal("clientId") === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
        this.decryptLocal("clientId") === "7203dd51-f88b-4a4b-877c-92326d027915" ||
        this.decryptLocal("clientId") === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
        this.decryptLocal("clientId") === "874b6c6a-83ff-480b-b615-1972538813ba" ||
        this.decryptLocal("clientId") === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
        this.decryptLocal("clientId") === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
        this.decryptLocal("clientId") === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
        this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
        this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
        this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
        this.decryptLocal("clientId") === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
        this.decryptLocal("clientId") === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
        this.decryptLocal("clientId") === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
        this.decryptLocal("clientId") === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
        this.decryptLocal("clientId") === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
        this.decryptLocal("clientId") === "535a90f3-b463-4d5a-9a83-39c522589a6c") &&
      (
        this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
        this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
      )
    ) {
      selectedRule = selectedRule.replace(
        "ca.dim_lifecycle",
        "di.dim_lifecycle"
      );
      selectedRule = selectedRule.replace("ca.geo_id_fav", "di.geo_id");
      selectedRule = selectedRule.replace(
        "((ca.loyalty = false AND di.geo_concept = '1' ))",
        "(((ca.loyalty = false OR ca.loyalty is null) AND di.geo_concept = '1'))"
      );
    }

    this.setState({ filtRule: selectedRule });

    // Prospect Specific Changes

    // console.log("Selected Rule is : " + selectedRule);
    // console.log("Model Decile Condition is : " + modelDecileSelectedRule);
    // console.log(
    //   "Non Model Decile Condition is : " + nonModelDecileSelectedRule
    // );

    let lastConditionModelDecile = modelDecileSelectedRule.slice(
      modelDecileSelectedRule.length - 4
    );
    if (lastConditionModelDecile.trim() == "AND") {
      modelDecileSelectedRule = modelDecileSelectedRule.slice(0, -4);
    }

    let lastConditionNonModelDecile = nonModelDecileSelectedRule.slice(
      nonModelDecileSelectedRule.length - 4
    );
    if (lastConditionNonModelDecile.trim() == "AND") {
      nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(0, -4);
      // nonModelDecileSelectedRule = nonModelDecileSelectedRule.slice(1);
    }
    let lastConditionSampling = samplingSelectedRule.slice(
      samplingSelectedRule.length - 4
    );
    if (lastConditionSampling.trim() == "AND") {
      samplingSelectedRule = samplingSelectedRule.slice(0, -4);
    }
    // console.log(
    //   "Model Decile After Removing Condition is : " + modelDecileSelectedRule
    // );
    // console.log(
    //   "Non Model Decile After Removing Condition is : " +
    //     nonModelDecileSelectedRule
    // );

    // console.log("Model Decile :" + modelDecileSelectedRule);
    // console.log("Non Model Decile :" + nonModelDecileSelectedRule);

    let selectedCustomerType = this.decryptLocal("selectedCustomerType");

    if (selectedCustomerType === "Acquistion") {
      this.setState({
        prospectFilterRuleForAutomation: nonModelDecileSelectedRule,
        modelDecileFilterRuleForAutomation: modelDecileSelectedRule,
        samplingFilterRuleForAutomation: samplingSelectedRule,
      });
    }
  }

  submitQuery = async (event, isReload) => {
    event.preventDefault();
    var flag = false;
    if (this.handleValidation()) {
      flag = true;
    } else {
      //this.state.showAcquistion = true;
      flag = false;
    }
    if (flag) {
      let group = this.state.groupTitle;
      let list = this.state.listDescription;
      const uuidv4 = require("uuid/v4");
      let path = "/audiences";
      await this.getSegmentCondition();
      await this.getWhereForSave();
      let myInit = {
        headers: {},
        body: {
          userId: this.decryptLocal("userId"),
          //query: JSON.parse(map),
          modifiedAt: new Date()
            .toJSON()
            .slice(0, 10)
            .replace(/-/g, "/"),
          title: group,
          description: list,
          customerType: this.state.customerType,
          clientId: this.state.clientId,

          prospectMinimum:
            this.state.localStorageClientId ===
              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
              this.state.localStorageClientId ===
              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
              this.state.localStorageClientId ===
              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
              this.state.localStorageClientId ===
              "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
              this.state.localStorageClientId ===
              "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
              this.state.localStorageClientId ===
              "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
              this.state.localStorageClientId ===
              "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
              this.state.localStorageClientId ===
              "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
              this.state.localStorageClientId ===
              "7abec586-17b8-4174-993d-e3d86648ed60" ||
              this.state.localStorageClientId ===
              "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
              this.state.localStorageClientId ===
              "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
              this.state.localStorageClientId ===
              "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
              this.state.localStorageClientId ===
              "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
              this.state.localStorageClientId ===
              "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
              this.state.localStorageClientId ===
              "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
              this.state.localStorageClientId ===
              "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
              this.state.localStorageClientId ===
              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
              this.state.localStorageClientId ===
              "7203dd51-f88b-4a4b-877c-92326d027915" ||
              this.state.localStorageClientId ===
              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
              this.state.localStorageClientId ===
              "874b6c6a-83ff-480b-b615-1972538813ba" ||
              this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
              this.state.localStorageClientId === 
                "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
              this.state.localStorageClientId === 
                "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
              this.state.localStorageClientId === 
                "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
              this.state.localStorageClientId === 
                "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
              this.state.localStorageClientId ===
               "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
              this.state.localStorageClientId === 
                "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
              this.state.localStorageClientId === 
                "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
              this.state.localStorageClientId ===
                "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
              this.state.localStorageClientId ===
                "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
              this.state.localStorageClientId ===
                "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
              ? this.state.prospectMinimumValue
              : "",
          prospectControlRadius:
            this.state.localStorageClientId ===
              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
              this.state.localStorageClientId ===
              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
              this.state.localStorageClientId ===
              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
              this.state.localStorageClientId ===
              "31a73952-d1bf-4647-af62-204b1f56596c" ||
              this.state.localStorageClientId ===
              "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
              this.state.localStorageClientId ===
              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
              this.state.localStorageClientId ===
              "7203dd51-f88b-4a4b-877c-92326d027915" ||
              this.state.localStorageClientId ===
              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
              this.state.localStorageClientId ===
              "874b6c6a-83ff-480b-b615-1972538813ba" ||
              this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
              this.state.localStorageClientId === 
              "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
              this.state.localStorageClientId === 
                "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
              this.state.localStorageClientId ===
                "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
              this.state.localStorageClientId === 
                "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
              this.state.localStorageClientId === 
                "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
              this.state.localStorageClientId ===
              "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
              this.state.localStorageClientId === 
                "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
              this.state.localStorageClientId === 
                "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
              this.state.localStorageClientId ===
                "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
              this.state.localStorageClientId ===
                "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
              this.state.localStorageClientId ===
                "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
              ? this.state.prospectControlRadius
              : "",
          maximumAudienceSize:
            this.state.localStorageClientId ===
              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
              this.state.localStorageClientId ===
              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
              this.state.localStorageClientId ===
              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
              this.state.localStorageClientId ===
              "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
              this.state.localStorageClientId ===
              "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
              this.state.localStorageClientId ===
              "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
              this.state.localStorageClientId ===
              "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
              this.state.localStorageClientId ===
              "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
              this.state.localStorageClientId ===
              "7abec586-17b8-4174-993d-e3d86648ed60" ||
              this.state.localStorageClientId ===
              "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
              this.state.localStorageClientId ===
              "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
              this.state.localStorageClientId ===
              "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
              this.state.localStorageClientId ===
              "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
              this.state.localStorageClientId ===
              "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
              this.state.localStorageClientId ===
              "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
              this.state.localStorageClientId ===
              "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
              this.state.localStorageClientId ===
              "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
              this.state.localStorageClientId ===
              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
              this.state.localStorageClientId ===
              "7203dd51-f88b-4a4b-877c-92326d027915" ||
              this.state.localStorageClientId ===
              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
              this.state.localStorageClientId ===
              "874b6c6a-83ff-480b-b615-1972538813ba" ||
              this.state.localStorageClientId === 
              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
              this.state.localStorageClientId === 
                "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
              this.state.localStorageClientId === 
                "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
              this.state.localStorageClientId === 
                "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
              this.state.localStorageClientId === 
                "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
              this.state.localStorageClientId === 
                "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
              this.state.localStorageClientId === 
                "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
              this.state.localStorageClientId === 
                "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
              this.state.localStorageClientId ===
                "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
              this.state.localStorageClientId ===
                "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
              this.state.localStorageClientId ===
                "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" 
              ? this.state.maximumAudienceSize
              : "",
          // bSqlSelectionArr:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.tillSqlSelectionArr
          //     : this.props.cust_tillSqlSelectionArr,
          // aSqlSelectionArr:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.afterSqlSelectionArr
          //     : this.props.cust_afterSqlSelectionArr,
          // groupLeveltoggle:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.groupLeveltoggle
          //     : this.props.cust_groupLeveltoggle,
          // ruleLeveltoggle:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.ruleLeveltoggle
          //     : this.props.cust_ruleLeveltoggle,
          // finalCount:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.temptotal_mkt),
          // emailCount:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(
          //         this.state.temptotal_audience_email_count
          //       ),
          // dmCount:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(
          //         this.state.temptotal_audience_email_eclub
          //       ),
          // fbCount:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(
          //         Math.round(parseInt(this.state.temptotal_mkt) * 0.5)
          //       ),
          // totCustomerCount:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(
          //         parseInt(this.state.temptotal_audience_email_pre) +
          //           parseInt(this.state.tempaddress_count)
          //       ),
          // preClubEmail:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.temptotal_audience_email_pre),
          // eclubEmail:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.tempaddress_count),
          // nonmktCustomer:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.temptotal_non_mkt),
          // noneclubEmails:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.tempnon_eclub_emails),
          // nonpreclubEmails:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.tempnon_preclub_emails),
          // nonemailCusts:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.tempnon_email_custs),
          // nonDirectmail:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(this.props.queryCount["query_count"])
          //     : this.numberWithCommas(this.state.tempnon_direct_mail),
          // segmentName:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.segmentName
          //     : this.props.cust_segmentName,
          // bSqlSelectionArrSegment:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.tillSqlSelectionArrSegment
          //     : this.props.cust_tillSqlSelectionArrSegment,
          // aSqlSelectionArrSegment:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.afterSqlSelectionArrSegment
          //     : this.props.cust_afterSqlSelectionArrSegment,
          // groupLeveltoggleSegment:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.groupLeveltoggleSegment
          //     : this.props.cust_groupLeveltoggleSegment,
          // ruleLeveltoggleSegment:
          //   this.state.customerType == "Acquistion"
          //     ? this.props.ruleLeveltoggleSegment
          //     : this.props.cust_ruleLeveltoggleSegment,
          // finalCountSegment:
          //   this.state.customerType == "Acquistion"
          //     ? this.numberWithCommas(
          //         this.props.queryCountSegment["query_count"]
          //       )
          //     : this.numberWithCommas(
          //         this.props.cust_queryCountSegment["query_count"]
          //       ),

          bSqlSelectionArr:
            this.state.customerType == "Acquistion"
              ? this.props.cust_tillSqlSelectionArr
              : this.props.cust_tillSqlSelectionArr,
          aSqlSelectionArr:
            this.state.customerType == "Acquistion"
              ? this.props.cust_afterSqlSelectionArr
              : this.props.cust_afterSqlSelectionArr,
          groupLeveltoggle:
            this.state.customerType == "Acquistion"
              ? this.props.cust_groupLeveltoggle
              : this.props.cust_groupLeveltoggle,
          ruleLeveltoggle:
            this.state.customerType == "Acquistion"
              ? this.props.cust_ruleLeveltoggle
              : this.props.cust_ruleLeveltoggle,
          finalCount:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.temptotal_mkt)
              : this.numberWithCommas(this.state.temptotal_mkt),
          emailCount:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.temptotal_audience_email_count)
              : this.numberWithCommas(
                this.state.temptotal_audience_email_count
              ),
          dmCount:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.temptotal_audience_email_eclub)
              : this.numberWithCommas(
                this.state.temptotal_audience_email_eclub
              ),
          fbCount:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(
                Math.round(parseInt(this.state.temptotal_mkt) * 0.5)
              )
              : this.numberWithCommas(
                Math.round(parseInt(this.state.temptotal_mkt) * 0.5)
              ),
          totCustomerCount:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(
                parseInt(this.state.temptotal_audience_email_pre) +
                parseInt(this.state.tempaddress_count)
              )
              : this.numberWithCommas(
                parseInt(this.state.temptotal_audience_email_pre) +
                parseInt(this.state.tempaddress_count)
              ),
          preClubEmail:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.state.temptotal_audience_email_pre)
              : this.numberWithCommas(this.state.temptotal_audience_email_pre),
          eclubEmail:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.tempaddress_count)
              : this.numberWithCommas(this.state.tempaddress_count),
          nonmktCustomer:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.temptotal_non_mkt)
              : this.numberWithCommas(this.state.temptotal_non_mkt),
          noneclubEmails:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.tempnon_eclub_emails)
              : this.numberWithCommas(this.state.tempnon_eclub_emails),
          nonpreclubEmails:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.tempnon_preclub_emails)
              : this.numberWithCommas(this.state.tempnon_preclub_emails),
          nonemailCusts:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.tempnon_email_custs)
              : this.numberWithCommas(this.state.tempnon_email_custs),
          nonDirectmail:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(this.props.tempnon_direct_mail)
              : this.numberWithCommas(this.state.tempnon_direct_mail),
          segmentName:
            this.state.customerType == "Acquistion"
              ? this.props.cust_segmentName
              : this.props.cust_segmentName,
          bSqlSelectionArrSegment:
            this.state.customerType == "Acquistion"
              ? this.props.cust_tillSqlSelectionArrSegment
              : this.props.cust_tillSqlSelectionArrSegment,
          aSqlSelectionArrSegment:
            this.state.customerType == "Acquistion"
              ? this.props.cust_afterSqlSelectionArrSegment
              : this.props.cust_afterSqlSelectionArrSegment,
          groupLeveltoggleSegment:
            this.state.customerType == "Acquistion"
              ? this.props.cust_groupLeveltoggleSegment
              : this.props.cust_groupLeveltoggleSegment,
          ruleLeveltoggleSegment:
            this.state.customerType == "Acquistion"
              ? this.props.cust_ruleLeveltoggleSegment
              : this.props.cust_ruleLeveltoggleSegment,
          finalCountSegment:
            this.state.customerType == "Acquistion"
              ? this.numberWithCommas(
                this.props.cust_queryCountSegment["query_count"]
              )
              : this.numberWithCommas(
                this.props.cust_queryCountSegment["query_count"]
              ),
          filterRule: this.state.filtRule,
          segmentRule: this.state.segRule,
          modelDecileProspectFilterRule: this.state
            .modelDecileFilterRuleForAutomation,
          nonModelDecileProspectFilterRule: this.state
            .prospectFilterRuleForAutomation,
          samplingFilterRule: this.state.samplingFilterRuleForAutomation,
          counts: this.decryptLocal("counts"),
          clientConcept: this.decryptLocal("globalFilter"),
        },
      };
      //POST's NEW record to the audiences table
      if (this.props.id !== undefined || this.state.audienceCreatedId !== 0) {
        myInit["body"]["createdAt"] = this.state.initalCreationDate;
        let audienceId =
          this.props.id !== undefined
            ? this.props.id
            : this.state.audienceCreatedId;
        myInit["headers"]["id"] = audienceId;
        myInit["body"]["id"] = audienceId;
        API.put(apiName, path, myInit)
          .then((response) => {
            this.handleClose("classicModal");
            this.setState({
              message: "Record saved successfully",
              color: "success",
              //demographicsInitValueJSON: ""
            });

            this.showNotification("tr");
            if (isReload) {
              setTimeout(
                function () {
                  window.location.reload(true);
                }.bind(this),
                1000
              );
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      } else {
        (myInit["body"]["createdAt"] = new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "/")),
          (myInit["body"]["id"] = uuidv4());
        API.post(apiName, path, myInit)
          .then((response) => {
            this.handleClose("classicModal");
            this.setState({
              initalCreationDate: myInit["body"]["createdAt"],
              audienceCreatedId: myInit["body"]["id"],
              message: "Record saved successfully",
              color: "success",
              //demographicsInitValueJSON: ""
            });

            this.showNotification("tr");
            if (isReload) {
              setTimeout(
                function () {
                  window.location.reload(true);
                }.bind(this),
                1000
              );
            }
          })
          .catch((error) => {
            console.log(error.response);
          });
      }
    }
  };

  showNotification = (place) => {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function () {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        6000
      );
    }
  };
  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };
  handleClickOpen = (modal) => {
    this.setState({
      fields: {},
      errors: {},
    });

    $("#groupTitle").val("");
    $("#listDescription").val("");
    var x = [];
    x[modal] = true;
    this.setState(x);
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  render() {
    if (this.state.redirect === true) {
      return <ViewAudiences />;
      // <Redirect push to={"/audiences/createAudiences/"} />;
    }
    const children = [];
    const { classes, theme } = this.props;
    var partial;

    const { open } = this.state;
    let showChartSpinner = 0;
    let showChartTotalSpinner = 0;
    let showSpinner = "";
    let showTotalSpinner = "";
    let showEmailSpinner = "";
    let showAddressSpinner = "";
    let showTable = "";
    let chartView = "";
    let summaryData = "";
    let showSpinnerChart = "";
    let showTotalFBSpinner = "";
    let showTotalSpinnerEP = "";
    let showTotalEmailSpinner = "";
    let displaySpinner = "";
    let showTotalEmailSpinnerPre = "";
    let showTotalEmailSpinnerEclub = "";
    let queryCountData =
      this.state.customerType == "Acquistion"
        ? this.props.queryCount
        : this.props.cust_queryCount;
    let showQuerySpinnerData =
      this.state.customerType == "Acquistion"
        ? this.props.showQuerySpinner
        : this.props.cust_showQuerySpinner;

    let tableData =
      this.state.customerType == "Acquistion"
        ? this.props.previewData.length > 0
          ? this.props.previewData[0]
          : []
        : this.props.cust_previewData.length > 0
          ? this.props.cust_previewData[0]
          : [];

    if (showQuerySpinnerData === "yes") {
      displaySpinner = "show";
      showSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showSpinnerChart = (
        <i
          className="fa fa-spinner fa-spin"
          style={{ fontSize: "18px", color: "#417a94", textAlign: "center" }}
        />
      );
      showTotalSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showEmailSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showAddressSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTotalEmailSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTotalEmailSpinnerPre = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTotalEmailSpinnerEclub = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTotalFBSpinner = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTotalSpinnerEP = (
        <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
      );
      showTable = (
        <div style={{ align: "center", width: "100%" }}>
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "50px" }} />
        </div>
      );
    } else {
      if (
        queryCountData["query_count"] === " " ||
        queryCountData["query_count"] === ""
      ) {
        showSpinner = 0;
        // <em className={this.state.activeTab === "Filter" ? "dark" : "light"}>
      } else {
        displaySpinner = "hide";
        showSpinnerChart = "";
        showChartSpinner = queryCountData["total_mkt"];
        showChartTotalSpinner = queryCountData["full_count"];
        chartView = " ";
        {
          /*(<DonutChart targetted={showChartSpinner} untargetted={showChartTotalSpinner} />)*/
        }
        // this.setState({changeStatus: 'yes'})
        //cust_count count
        showSpinner = this.numberWithCommas(
          //queryCountData["query_count"]
          parseInt(queryCountData["total_audience_email_pre"]) +
          parseInt(queryCountData["address_count"])
        );
        this.state.tempquery_count = queryCountData["query_count"];

        showTotalSpinner = this.numberWithCommas(queryCountData["full_count"]);

        showEmailSpinner = this.numberWithCommas(queryCountData["email_count"]);

        showAddressSpinner = this.numberWithCommas(
          queryCountData["address_count"]
        );

        //Email Counts
        showTotalEmailSpinner = this.numberWithCommas(
          queryCountData["total_audience_email_count"]
        );
        this.state.temptotal_audience_email_count =
          queryCountData["total_audience_email_count"];

        showTotalEmailSpinnerPre = this.numberWithCommas(
          queryCountData["total_audience_email_pre"]
        );

        //DM COUNTS
        showTotalEmailSpinnerEclub = this.numberWithCommas(
          queryCountData["total_audience_email_eclub"]
        );
        this.state.temptotal_audience_email_eclub =
          queryCountData["total_audience_email_eclub"];

        showTotalFBSpinner = this.numberWithCommas(
          Math.round(queryCountData["query_count"] * 0.5)
        );
        //this.state.this.state.tempquery_count =  queryCountData["query_count"]
        showTotalSpinnerEP = this.numberWithCommas(
          parseInt(queryCountData["total_audience_email_pre"]) +
          parseInt(queryCountData["address_count"])
        );
        this.state.temptotal_audience_email_pre = parseInt(
          queryCountData["total_audience_email_pre"]
        );
        this.state.tempaddress_count = parseInt(
          queryCountData["address_count"]
        );

        this.state.temptotal_non_mkt = queryCountData["total_non_mkt"];
        this.state.temptotal_mkt = queryCountData["total_mkt"];

        this.state.tempnon_eclub_emails = queryCountData["non_eclub_emails"];
        this.state.tempnon_preclub_emails =
          queryCountData["non_preclub_emails"];
        this.state.tempnon_email_custs = queryCountData["non_email_custs"];
        this.state.tempnon_direct_mail = queryCountData["non_direct_mail"];

        summaryData = (
          <React.Fragment>
            {/*<p style={{textAlign:"center", color:"#417a94"}}><h2 style={{display: "inline"}}>{showSpinner}</h2> of <h2 style={{display: "inline"}}>{showTotalSpinner}</h2></p> 
           <p style={{textAlign:"center", color:"#417a94"}}>targeted audience members</p> 
          <br/>*/}
            {/*all_custs */}
            {/*<br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>CUSTOMERS</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showSpinner}</h2> 
           <br/>
           {email custs }
           <br/>
           <h2 style={{textAlign:"left", paddingLeft: "30px", float:"left", color:"#417a94"}}>WITH EMAIL</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalEmailSpinner}</h2> 
           <br/>
           {DM DIRECT }
           <br/>
           <h2 style={{textAlign:"left", paddingLeft: "30px", float:"left", color:"#417a94"}}>WITH DM Mail</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalEmailSpinnerEclub}</h2> 
           <br/>
           {FB DIRECT }
           <br/>
           <h2 style={{textAlign:"left", paddingLeft: "30px", float:"left", color:"#417a94"}}>WITH FB</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalFBSpinner}</h2> 
           <br/>
           {TOTAL EMAILS }
           <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>TOTAL EMAILS</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalSpinnerEP}</h2> 
           <br/>*/}
            {/*
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Preclub Customers</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showEmailSpinner}</h2> 
           <br/>
           <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Eclub Emails</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showAddressSpinner}</h2> 
           <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Eclub Customers</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalSpinner}</h2> 
           <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Email Customers</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalEmailSpinner}</h2> 
          <br/>
          <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Preclub Emails</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalEmailSpinnerPre}</h2> 
          <br/>
          <br/>
           <h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Direct Mail</h2> 
           <h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{showTotalEmailSpinnerEclub}</h2> 
          <br/>*/}
          </React.Fragment>
        );

        showTable = (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>City</TableCell>
                <TableCell>State</TableCell>
                <TableCell>Zip</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {tableData.length > 0
                ? tableData.map((list, idx) => {
                  return (
                    <TableRow striped hover key={idx}>
                      <TableCell>{list.cac_name_first}</TableCell>
                      <TableCell>{list.cac_addr_full}</TableCell>
                      <TableCell>{list.cac_addr_city}</TableCell>
                      <TableCell>{list.cac_addr_state}</TableCell>
                      <TableCell>{list.cac_addr_zip}</TableCell>
                    </TableRow>
                  );
                })
                : ""}
            </TableBody>
          </Table>
        );
      }
    }
    if (this.state.created) {
      return <ViewAudiences />;
    }
    var content;
    if (this.state.activeTab === "Filter") {
      content =
        this.state.isAcquistionClicked === true ||
          this.state.isCustomerClicked === true ? (
          <div>
            {/*<div
              style={{
                float: "right",
                display: "inlineBlock",
                paddingRight: "20px",
                // border: "1px solid red"
              }}
            >
              <GroupModal
                titleName="Add Filter"
                buttonLabel="Group"
                selectedIndex="no_index"
                selectedRule=""
                mode="Create"
                type="group"
                buttonType="add group"
              />
            </div> */}
            <GridContainer style={{ marginBottom: "0px" }}>
              <GridItem xs={8} sm={8} md={8} xl={8}>
                <Card
                  style={{
                    textAlign: "left",
                    marginBottom: "0px",
                  }}
                >
                  <div className="filtercentercontent summarycontent">
                    <div
                      className="filteraudiencetitle summarytitle"
                      style={{ minHeight: "40px" }}
                    >
                      <h2 className="capitalize">Filter Criteria</h2>
                      <a href="javascript:void(0)" style={{ float: "right" }}>
                        {this.state.customerType == "Acquistion" ? (
                          <CGroupModal
                            titleName="Add Filter"
                            buttonLabel="Add Filter"
                            selectedIndex="no_index"
                            selectedRule=""
                            mode="Create"
                            type="group"
                            buttonType="add group"
                            class="withoutbgbtn"
                            style={{ marginRight: "0px" }}
                          />
                        ) : (
                          <CGroupModal
                            titleName="Add Filter"
                            buttonLabel="Add Filter"
                            selectedIndex="no_index"
                            selectedRule=""
                            mode="Create"
                            type="group"
                            buttonType="add group"
                            class="withoutbgbtn"
                            style={{ marginRight: "0px" }}
                          />
                        )}
                      </a>
                    </div>
                    <CardBody
                      style={{
                        textAlign: "left",
                        // overflowY: "auto",
                        minHeight: "370px",
                        marginBottom: "0px",
                      }}
                    >
                      <div className="filtercentercontent">
                        <div className="">
                          {/* <div class="btngroup">
                        <a href="javascript:void(0)" class="btn">
                          <i class="plussign" />
                          add group
                        </a>
                      </div> */}
                          {this.state.customerType == "Acquistion" ? (
                            <CResult onButton="" />
                          ) : (
                            <CResult onButton="" />
                          )}
                          <center>
                            {(this.state.customerType == "Acquistion") && (this.state.localStorageClientId ===
                              "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                              this.state.localStorageClientId ===
                              "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                              this.state.localStorageClientId ===
                              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                              this.state.localStorageClientId ===
                              "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
                              this.state.localStorageClientId ===
                              "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
                              this.state.localStorageClientId ===
                              "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
                              this.state.localStorageClientId ===
                              "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
                              this.state.localStorageClientId ===
                              "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
                              this.state.localStorageClientId ===
                              "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
                              this.state.localStorageClientId ===
                              "7abec586-17b8-4174-993d-e3d86648ed60" ||
                              this.state.localStorageClientId ===
                              "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
                              this.state.localStorageClientId ===
                              "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
                              this.state.localStorageClientId ===
                              "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
                              this.state.localStorageClientId ===
                              "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
                              this.state.localStorageClientId ===
                              "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
                              this.state.localStorageClientId ===
                              "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                              this.state.localStorageClientId ===
                              "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
                              this.state.localStorageClientId ===
                              "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
                              this.state.localStorageClientId ===
                              "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                              this.state.localStorageClientId ===
                              "7203dd51-f88b-4a4b-877c-92326d027915" ||
                              this.state.localStorageClientId ===
                              "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                              this.state.localStorageClientId ===
                                "874b6c6a-83ff-480b-b615-1972538813ba" ||
                              this.state.localStorageClientId === 
                              "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                              this.state.localStorageClientId === 
                              "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
                              this.state.localStorageClientId === 
                                "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                              this.state.localStorageClientId === 
                                "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                              this.state.localStorageClientId === 
                                "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                              this.state.localStorageClientId === 
                                "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                              this.state.localStorageClientId === 
                                "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                              this.state.localStorageClientId === 
                                "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                              this.state.localStorageClientId ===
                                "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                              this.state.localStorageClientId ===
                                "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                              this.state.localStorageClientId ===
                                "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) &&
                              (this.decryptLocal("activeChannel") == "d977fc2b-2352-473b-9a54-b80765f0400c" ||
                                this.decryptLocal("activeChannel") == "79b91604-9f03-428a-9026-9be77ca9a687" ||
                                this.decryptLocal("activeChannel") == "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
                                this.decryptLocal("activeChannel") == "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
                                this.decryptLocal("activeChannel") == "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" ||
                                this.decryptLocal("activeChannel") == "2c77a7b6-60e9-4c75-819e-e93b60d47b82")
                              // &&
                              // (this.state.localStorageGroupId ===
                              //   "dc761ead-b491-4bcc-80c8-b9b7d12350ae" ||
                              //   this.state.localStorageGroupId ===
                              //     "b6859251-b799-4bf2-aa0b-f2eaad3a81fd")
                              && (
                                <GridItem xs={12} sm={12} md={12}>
                                  <div
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    <Button
                                      color="secondary"
                                      onClick={() =>
                                        this.setState({
                                          prospectInputsModal: true,
                                        })
                                      }
                                    >
                                      <b>Prospect Limits</b>
                                    </Button>
                                  </div>
                                </GridItem>
                              )}
                          </center>
                          <center>
                            <Dialog
                              classes={{
                                root: classes.center + " " + classes.modalRoot,
                                paper: classes.modal,
                              }}
                              open={this.state.prospectInputsModal}
                              TransitionComponent={Transition}
                              //keepMounted
                              disableBackdropClick
                              disableEscapeKeyDown
                              onClose={() =>
                                this.handleClose("prospectInputsModal")
                              }
                              aria-labelledby="classic-modal-slide-title"
                              aria-describedby="classic-modal-slide-description"
                            >
                              <DialogTitle
                                id="classic-modal-slide-title"
                                disableTypography
                                className={classes.modalHeader}
                                style={{
                                  backgroundColor: "#69ff45",
                                  borderTopLeftRadius: "6px",
                                  borderTopRightRadius: "6px",
                                  width: "500px",
                                }}
                              >
                                <h4
                                  className={classes.modalTitle}
                                  style={{ color: "#fff" }}
                                >
                                  <strong>
                                    {this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c"
                                      ? "Email Prospect Limits"
                                      : "Display Prospect Limits"}
                                  </strong>
                                </h4>
                              </DialogTitle>
                              <DialogContent
                                id="classic-modal-slide-description"
                                className={classes.modalBody}
                              >
                                <div>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      {
                                        <div>
                                          <div>
                                            <TextField
                                              style={{
                                                width: "80%",
                                              }}
                                              label="Minimum Prospects Per Location"
                                              value={
                                                this.state.prospectMinimumValue
                                              }
                                              onChange={(event) =>
                                                this.prospectMinimumOnChange(
                                                  event
                                                )
                                              }
                                              type="number"
                                              name="number_field_name_range"
                                              inputProps={{
                                                min: 0,
                                                // max: options.label,
                                                // shrink: true,
                                                // key: key,
                                              }}
                                              margin="normal"
                                            />
                                          </div>
                                          <span
                                            className="redColor"
                                            style={{
                                              width: "100%",
                                            }}
                                          >
                                            {
                                              this.state.errors[
                                              "prospectsMinimum"
                                              ]
                                            }
                                          </span>
                                          <div>
                                            <TextField
                                              style={{
                                                width: "80%",
                                              }}
                                              label="Maximum Audience Size"
                                              value={
                                                this.state.maximumAudienceSize
                                              }
                                              onChange={(event) =>
                                                this.maximumAudienceSizeOnChange(
                                                  event
                                                )
                                              }
                                              type="number"
                                              name="number_field_name_range"
                                              inputProps={{
                                                min: 0,
                                                // max: options.label,
                                                // shrink: true,
                                                // key: key,
                                              }}
                                              margin="normal"
                                            />
                                          </div>
                                          <span
                                            className="redColor"
                                            style={{
                                              width: "100%",
                                            }}
                                          >
                                            {
                                              this.state.errors[
                                              "maximumAudienceSize"
                                              ]
                                            }
                                          </span>
                                        </div>
                                      }
                                    </GridItem>
                                  </GridContainer>
                                </div>
                              </DialogContent>
                              <DialogActions className={classes.modalFooter}>
                                <Button
                                  onClick={() =>
                                    this.handleProspectsValidataion()
                                  }
                                  className="btn btncreate"
                                  color="secondary"
                                >
                                  Close
                                </Button>
                                <Button
                                  className="btn btncreate"
                                  color="secondary"
                                  onClick={(event) => {
                                    this.fetchProspectCounts(event);
                                  }}
                                >
                                  Fetch Counts
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </center>
                          <br />
                        </div>
                      </div>
                    </CardBody>
                  </div>
                </Card>
              </GridItem>
              <GridItem xs={4} sm={4} md={4} xl={4}>
                {this.state.loadingInitalSpinner == "true" ? (
                  <Card
                    style={{
                      marginBottom: "0px",
                    }}
                  >
                    <div className="filtercentercontent summarycontent">
                      <div
                        className="filteraudiencetitle summarytitle"
                        style={{ minHeight: "40px" }}
                      >
                        <h2 className="capitalize">
                          {this.decryptLocal("activeChannel") !== "d977fc2b-2352-473b-9a54-b80765f0400c" &&
                            this.decryptLocal("activeChannel") !== "79b91604-9f03-428a-9026-9be77ca9a687" &&
                            this.decryptLocal("activeChannel") !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" &&
                            this.decryptLocal("activeChannel") !== "2c77a7b6-60e9-4c75-819e-e93b60d47b82"
                            ? this.state.summaryBoxHeaderText
                            : "Summary"}
                        </h2>
                      </div>
                      <CardBody
                        style={{
                          height: "200px",
                          textAlign: "center",
                          marginBottom: "0px",
                        }}
                      >
                        {/* <Select
                          value={
                            this.state.channelsDropDown.filter(
                              (o) =>
                                o.value ===
                                this.decryptLocal("activeChannel")
                            )[0]
                          }
                          onChange={this.handleChannelDropDownChange}
                          options={this.state.channelsDropDown}
                        /> */}
                        <i
                          className="fa fa-spinner fa-spin"
                          style={{ fontSize: "18px" }}
                        />
                      </CardBody>
                    </div>

                    <CardFooter stats />
                  </Card>
                ) : (
                  <Card
                    style={{
                      marginBottom: "0px",
                    }}
                  >
                    {this.state.localStorageClientId ===
                      "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                      this.state.localStorageClientId ===
                      "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                      this.state.localStorageClientId ===
                      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                      this.state.localStorageClientId ===
                      "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
                      this.state.localStorageClientId ===
                      "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                      this.state.localStorageClientId ===
                      "7203dd51-f88b-4a4b-877c-92326d027915" ||
                      this.state.localStorageClientId ===
                      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                      this.state.localStorageClientId ===
                      "874b6c6a-83ff-480b-b615-1972538813ba" ||
                      this.state.localStorageClientId === 
                      "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                      this.state.localStorageClientId === 
                      "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
                      this.state.localStorageClientId === 
                        "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                      this.state.localStorageClientId === 
                        "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                      this.state.localStorageClientId === 
                        "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                      this.state.localStorageClientId === 
                        "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                      this.state.localStorageClientId ===
                      "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
                      this.state.localStorageClientId === 
                        "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                      this.state.localStorageClientId === 
                        "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                      this.state.localStorageClientId ===
                        "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                      this.state.localStorageClientId ===
                        "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                      this.state.localStorageClientId ===
                        "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ? (
                      <div className="filtercentercontent summarycontent">
                        <div
                          className="filteraudiencetitle summarytitle"
                          style={{ minHeight: "40px" }}
                        >
                          {/* <h2 className="capitalize">Summary DIS-ACQ</h2> */}
                          <h2 className="capitalize">
                            {this.decryptLocal("activeChannel") !== "d977fc2b-2352-473b-9a54-b80765f0400c" &&
                              this.decryptLocal("activeChannel") !== "79b91604-9f03-428a-9026-9be77ca9a687" &&
                              this.decryptLocal("activeChannel") !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" &&
                              this.decryptLocal("activeChannel") !== "2c77a7b6-60e9-4c75-819e-e93b60d47b82"
                              ? this.state.summaryBoxHeaderText
                              : "Summary"}
                          </h2>
                        </div>

                        {this.state.customerType === "Acquistion" ? (
                          <LoadingOverlay
                            active={this.props.overlaySpinner}
                            spinner
                            text="Fetching Counts..."
                          >
                            <CardBody
                              style={{
                                textAlign: "center",
                                marginBottom: "0px",
                                minHeight: "100px",
                              }}
                            >
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                  <h2
                                    style={{
                                      textAlign: "left",
                                      float: "left",
                                      color: "#417a94",
                                    }}
                                  >
                                    Total Prospects
                                  </h2>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                  <h2
                                    style={{
                                      textAlign: "right",
                                      float: "right",
                                      color: "#417a94",
                                      paddingRight: "35px",
                                    }}
                                  >
                                    {this.numberWithCommas(
                                      "total_customers" in
                                        this.props.filter_result_json
                                        ? this.props.filter_result_json[
                                        "total_customers"
                                        ]["total"]
                                        : 0
                                    )}
                                  </h2>
                                </GridItem>
                              </GridContainer>
                              <hr />
                              {Object.keys(
                                Object.keys(this.props.filter_result_json)
                                  .filter(
                                    (key) =>
                                      JSON.parse(
                                        CryptoJS.AES.decrypt(
                                          localStorage.getItem(
                                            "selectedCustomerType"
                                          ),
                                          process.env.REACT_APP_PASS
                                        ).toString(CryptoJS.enc.Utf8)
                                      ) === "Customer" &&
                                        (
                                          this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
                                          this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
                                        )
                                        ? key != "emails" &&
                                        key != "total_customers"
                                        : key != "total_customers"
                                  )
                                  .reduce((obj, key) => {
                                    obj[key] = this.props.filter_result_json[
                                      key
                                    ];
                                    return obj;
                                  }, {})
                              ).map((subs) => (
                                <GridContainer
                                  style={{
                                    paddingTop: "10px",
                                  }}
                                >
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "left",
                                        float: "left",
                                        color: "#417a94",
                                        paddingBottom: "10px",
                                      }}
                                    >
                                      {this.propercase(subs)}
                                    </h2>
                                  </GridItem>
                                  {Object.keys(
                                    this.props.filter_result_json[subs]
                                  ).map((sub1) => (
                                    <GridContainer
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            paddingLeft: "50px",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          {this.propercase(sub1)}
                                        </h2>{" "}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                            color: "#417a94",
                                            paddingRight: "50px",
                                          }}
                                        >
                                          {this.numberWithCommas(
                                            this.props.filter_result_json[subs][
                                            sub1
                                            ]
                                          )}
                                        </h2>
                                      </GridItem>
                                    </GridContainer>
                                  ))}
                                </GridContainer>
                              ))}
                            </CardBody>
                          </LoadingOverlay>
                        ) : (
                          <LoadingOverlay
                            active={this.props.overlaySpinner}
                            spinner
                            text="Fetching Counts..."
                          >
                            {/* Kahala Customer All Channels Summary */}

                            {((
                              this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
                              this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
                            ) ||
                              this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91") && (
                                <CardBody
                                  style={{
                                    //height: "375px",
                                    textAlign: "center",
                                    marginBottom: "0px",
                                  }}
                                >
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Total Customers
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "35px",
                                        }}
                                      >
                                        {this.numberWithCommas(
                                          "total_customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "total_customers"
                                            ]["total"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  {/* <Select
                                  value={
                                    this.state.channelsDropDown.filter(
                                      (o) =>
                                        o.value ===
                                        JSON.parse(
                                          CryptoJS.AES.decrypt(
                                            localStorage.getItem(
                                              "activeChannel"
                                            ),
                                            process.env.REACT_APP_PASS
                                          ).toString(CryptoJS.enc.Utf8)
                                        )
                                    )[0]
                                  }
                                  onChange={this.handleChannelDropDownChange}
                                  options={this.state.channelsDropDown}
                                /> */}
                                  <hr />

                                  <GridContainer
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Customers
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  <GridContainer>
                                    <GridContainer
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            paddingLeft: "50px",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          Control Group
                                        </h2>{" "}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                            color: "#417a94",
                                            paddingRight: "50px",
                                          }}
                                        >
                                          {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                          {this.numberWithCommas(
                                            "customers" in this.props.filter_result_json ? (
                                              this.props.filter_result_json["customers"]["control"] === undefined ? this.props.filter_result_json["customers"]["control group"] : this.props.filter_result_json["customers"]["control"]
                                            ) : 0
                                          )}
                                        </h2>
                                      </GridItem>
                                    </GridContainer>
                                    <GridContainer
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            paddingLeft: "50px",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          Marketable
                                        </h2>{" "}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                            color: "#417a94",
                                            paddingRight: "50px",
                                          }}
                                        >
                                          {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                          {this.numberWithCommas(
                                            "customers" in
                                              this.props.filter_result_json
                                              ? this.props.filter_result_json[
                                              "customers"
                                              ]["marketable"]
                                              : 0
                                          )}
                                        </h2>
                                      </GridItem>
                                    </GridContainer>
                                    <GridContainer
                                      style={{ paddingBottom: "10px" }}
                                    >
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            paddingLeft: "50px",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          Total
                                        </h2>{" "}
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "right",
                                            float: "right",
                                            color: "#417a94",
                                            paddingRight: "50px",
                                          }}
                                        >
                                          {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                          {this.numberWithCommas(
                                            "customers" in
                                              this.props.filter_result_json
                                              ? this.props.filter_result_json[
                                              "customers"
                                              ]["total"]
                                              : 0
                                          )}
                                        </h2>
                                      </GridItem>
                                    </GridContainer>
                                  </GridContainer>
                                </CardBody>
                              )}

                            {(this.decryptLocal("clientId") === "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                              this.decryptLocal("clientId") === "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
                              this.decryptLocal("clientId") === "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                              this.decryptLocal("clientId") === "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                              this.decryptLocal("clientId") === "7203dd51-f88b-4a4b-877c-92326d027915" ||
                              this.decryptLocal("clientId") === "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                              this.decryptLocal("clientId") === "874b6c6a-83ff-480b-b615-1972538813ba" ||
                              this.decryptLocal("clientId") === "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                              this.decryptLocal("clientId") === "e08840c5-c7d0-48c7-9c24-124b4cd80735" || 
                              this.decryptLocal("clientId") === "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                              this.state.localStorageClientId === "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                              this.state.localStorageClientId === "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                              this.state.localStorageClientId === "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                              this.decryptLocal("clientId") === "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                              this.decryptLocal("clientId") === "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                              this.decryptLocal("clientId") === "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                              this.decryptLocal("clientId") === "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                              this.decryptLocal("clientId") === "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ||
                              this.decryptLocal("clientId") === "535a90f3-b463-4d5a-9a83-39c522589a6c") &&
                              (this.decryptLocal("activeChannel") === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
                                this.decryptLocal("activeChannel") === "3b3e90db-f06b-4ba4-9fbb-769637647ab0" ||
                                this.decryptLocal("activeChannel") === "c2a842ba-36cc-46b7-8fa4-3a361708b34b" ||
                                this.decryptLocal("activeChannel") === "25c7cb9a-a192-46f5-b32d-49e8d52afea8" ||
                                this.decryptLocal("activeChannel") === "f786cb0f-eecc-4b87-adef-34eb20f3f766" ||
                                this.decryptLocal("activeChannel") === "3c8a9cf7-a0b2-4845-8436-d598181e6d78" ||
                                this.decryptLocal("activeChannel") === "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" ||
                                this.decryptLocal("activeChannel") === "33bc71b1-4495-43f0-ab64-17ed38270e04") && (
                                <CardBody
                                  style={{
                                    //height: "375px",
                                    textAlign: "center",
                                    marginBottom: "0px",
                                  }}
                                >
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Total Customers
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "35px",
                                        }}
                                      >
                                        {this.numberWithCommas(
                                          "total_customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "total_customers"
                                            ]["total"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  {/* <Select
                                    value={
                                      this.state.channelsDropDown.filter(
                                        (o) =>
                                          o.value ===
                                          JSON.parse(
                                            CryptoJS.AES.decrypt(
                                              localStorage.getItem(
                                                "activeChannel"
                                              ),
                                              process.env.REACT_APP_PASS
                                            ).toString(CryptoJS.enc.Utf8)
                                          )
                                      )[0]
                                    }
                                    onChange={this.handleChannelDropDownChange}
                                    options={this.state.channelsDropDown}
                                  /> */}
                                  <hr />
                                  {/*displaySpinner === "show" ? showSpinnerChart : displaySpinner === "hide" ? chartView : ""*/}
                                  {/*displaySpinner === "hide" ? summaryData : "" */}
                                  {Object.keys(
                                    Object.keys(this.props.filter_result_json)
                                      .filter((key) => key != "total_customers")
                                      .reduce((obj, key) => {
                                        obj[
                                          key
                                        ] = this.props.filter_result_json[key];
                                        return obj;
                                      }, {})
                                  ).map((subs) => (
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          {this.propercase(subs)}
                                        </h2>{" "}
                                      </GridItem>
                                      {Object.keys(
                                        this.props.filter_result_json[subs]
                                      ).map((sub1) => (
                                        <GridContainer
                                          style={{ paddingBottom: "10px" }}
                                        >
                                          <GridItem xs={12} sm={12} md={6}>
                                            <h2
                                              style={{
                                                textAlign: "left",
                                                paddingLeft: "50px",
                                                float: "left",
                                                color: "#417a94",
                                              }}
                                            >
                                              {this.propercase(sub1)}
                                            </h2>{" "}
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={6}>
                                            <h2
                                              style={{
                                                textAlign: "right",
                                                float: "right",
                                                color: "#417a94",
                                                paddingRight: "50px",
                                              }}
                                            >
                                              {this.numberWithCommas(
                                                this.props.filter_result_json[
                                                subs
                                                ][sub1]
                                              )}
                                            </h2>
                                          </GridItem>
                                        </GridContainer>
                                      ))}
                                    </GridContainer>
                                  ))}
                                </CardBody>
                              )}
                            {/* Lou Malnatis Customer -> All Channels Summary */}
                            {this.state.localStorageClientId ===
                              "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" &&
                              (
                                this.decryptLocal("activeChannel") !== "d1606aea-0c0d-4fba-83e8-a124f414a953" &&
                                this.decryptLocal("activeChannel") !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
                              ) && (
                                <CardBody
                                  style={{
                                    //height: "375px",
                                    textAlign: "center",
                                    marginBottom: "0px",
                                  }}
                                >
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Total Customers
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "35px",
                                        }}
                                      >
                                        {this.numberWithCommas(
                                          "total_customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "total_customers"
                                            ]["total"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  {/* <Select
                                    value={
                                      this.state.channelsDropDown.filter(
                                        (o) =>
                                          o.value ===
                                          JSON.parse(
                                            CryptoJS.AES.decrypt(
                                              localStorage.getItem(
                                                "activeChannel"
                                              ),
                                              process.env.REACT_APP_PASS
                                            ).toString(CryptoJS.enc.Utf8)
                                          )
                                      )[0]
                                    }
                                    onChange={this.handleChannelDropDownChange}
                                    options={this.state.channelsDropDown}
                                  /> */}
                                  <hr />
                                  {/*displaySpinner === "show" ? showSpinnerChart : displaySpinner === "hide" ? chartView : ""*/}
                                  {/*displaySpinner === "hide" ? summaryData : "" */}
                                  {Object.keys(
                                    Object.keys(this.props.filter_result_json)
                                      .filter((key) => key != "total_customers")
                                      .reduce((obj, key) => {
                                        obj[
                                          key
                                        ] = this.props.filter_result_json[key];
                                        return obj;
                                      }, {})
                                  ).map((subs) => (
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <h2
                                          style={{
                                            textAlign: "left",
                                            float: "left",
                                            color: "#417a94",
                                          }}
                                        >
                                          {this.propercase(subs)}
                                        </h2>{" "}
                                      </GridItem>
                                      {Object.keys(
                                        this.props.filter_result_json[subs]
                                      ).map((sub1) => (
                                        <GridContainer
                                          style={{ paddingBottom: "10px" }}
                                        >
                                          <GridItem xs={12} sm={12} md={6}>
                                            <h2
                                              style={{
                                                textAlign: "left",
                                                paddingLeft: "50px",
                                                float: "left",
                                                color: "#417a94",
                                              }}
                                            >
                                              {this.propercase(sub1)}
                                            </h2>{" "}
                                          </GridItem>
                                          <GridItem xs={12} sm={12} md={6}>
                                            <h2
                                              style={{
                                                textAlign: "right",
                                                float: "right",
                                                color: "#417a94",
                                                paddingRight: "50px",
                                              }}
                                            >
                                              {this.numberWithCommas(
                                                this.props.filter_result_json[
                                                subs
                                                ][sub1]
                                              )}
                                            </h2>
                                          </GridItem>
                                        </GridContainer>
                                      ))}
                                    </GridContainer>
                                  ))}
                                </CardBody>
                              )}
                          </LoadingOverlay>
                        )}
                      </div>
                    ) : (
                      // Except DIS-ACQ
                      <div className="filtercentercontent summarycontent">
                        <div
                          className="filteraudiencetitle summarytitle"
                          style={{ minHeight: "40px" }}
                        >
                          {/* <h2 className="capitalize">Summary Normal</h2> */}
                          <h2 className="capitalize">
                            {this.decryptLocal("activeChannel") !== "d977fc2b-2352-473b-9a54-b80765f0400c" &&
                              this.decryptLocal("activeChannel") !== "79b91604-9f03-428a-9026-9be77ca9a687"
                              ? this.state.summaryBoxHeaderText
                              : "Summary"}
                          </h2>
                        </div>
                        <LoadingOverlay
                          active={this.props.overlaySpinner}
                          spinner
                          text="Fetching Counts..."
                        >
                          {(
                            this.decryptLocal("activeChannel") !== "d1606aea-0c0d-4fba-83e8-a124f414a953" &&
                            this.decryptLocal("activeChannel") !== "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
                          ) && (
                              <CardBody
                                style={{
                                  //height: "375px",
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}
                              >
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "left",
                                        float: "left",
                                        color: "#417a94",
                                      }}
                                    >
                                      Total Customers
                                    </h2>{" "}
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "right",
                                        float: "right",
                                        color: "#417a94",
                                        paddingRight: "35px",
                                      }}
                                    >
                                      {this.numberWithCommas(
                                        "total_customers" in
                                          this.props.filter_result_json
                                          ? this.props.filter_result_json[
                                          "total_customers"
                                          ]["total"]
                                          : 0
                                      )}
                                    </h2>
                                  </GridItem>
                                </GridContainer>
                                {/* <Select
                                value={
                                  this.state.channelsDropDown.filter(
                                    (o) =>
                                      o.value ===
                                      this.decryptLocal("activeChannel")
                                  )[0]
                                }
                                onChange={this.handleChannelDropDownChange}
                                options={this.state.channelsDropDown}
                              /> */}
                                <hr />
                                {/*displaySpinner === "show" ? showSpinnerChart : displaySpinner === "hide" ? chartView : ""*/}
                                {/*displaySpinner === "hide" ? summaryData : "" */}
                                {Object.keys(
                                  Object.keys(this.props.filter_result_json)
                                    .filter((key) => key != "total_customers")
                                    .reduce((obj, key) => {
                                      obj[key] = this.props.filter_result_json[
                                        key
                                      ];
                                      return obj;
                                    }, {})
                                ).map((subs) => (
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        {this.propercase(subs)}
                                      </h2>{" "}
                                    </GridItem>
                                    {Object.keys(
                                      this.props.filter_result_json[subs]
                                    ).map((sub1) => (
                                      <GridContainer
                                        style={{ paddingBottom: "10px" }}
                                      >
                                        <GridItem xs={12} sm={12} md={6}>
                                          <h2
                                            style={{
                                              textAlign: "left",
                                              paddingLeft: "50px",
                                              float: "left",
                                              color: "#417a94",
                                            }}
                                          >
                                            {this.propercase(sub1)}
                                          </h2>{" "}
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <h2
                                            style={{
                                              textAlign: "right",
                                              float: "right",
                                              color: "#417a94",
                                              paddingRight: "50px",
                                            }}
                                          >
                                            {this.numberWithCommas(
                                              this.props.filter_result_json[subs][
                                              sub1
                                              ]
                                            )}
                                          </h2>
                                        </GridItem>
                                      </GridContainer>
                                    ))}
                                  </GridContainer>
                                ))}
                                {/*<GridContainer>
                          <GridItem xs={12} sm={12} md={6} ></GridItem>
                          <GridItem xs={12} sm={12} md={3} ><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>Marketable</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3} ><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>Control</h2></GridItem>
                      </GridContainer>
                      <hr/>
                      <GridContainer style={{paddingBottom:"12px"}}>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Customers</h2> </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.temptotal_mkt)}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.temptotal_non_mkt)}</h2></GridItem>
                      </GridContainer>
                      
                      <GridContainer style={{paddingBottom:"12px"}}>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", paddingLeft: "20px", float:"left", color:"#417a94"}}>With Email</h2> </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.temptotal_audience_email_count)}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.tempnon_email_custs)}</h2></GridItem>
                      </GridContainer>
                     
                      <GridContainer style={{paddingBottom:"12px"}}>
                          <GridItem xs={12} sm={12} md={6} ><h2 style={{textAlign:"left", paddingLeft: "20px", float:"left", color:"#417a94"}}>With Direct Mail</h2>  </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.temptotal_audience_email_eclub)}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(this.state.tempnon_direct_mail)}</h2></GridItem>
                      </GridContainer>
                      
                      <GridContainer>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", paddingLeft: "20px", float:"left", color:"#417a94"}}>With Facebook</h2>  </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(Math.round(this.state.temptotal_mkt * 0.5 ))}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(Math.round(this.state.temptotal_non_mkt * 0.5 ))}</h2></GridItem>
                      </GridContainer>
                      <hr/>
                      <GridContainer style={{paddingBottom:"12px"}}>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", float:"left", color:"#417a94"}}>Total Emails</h2>   </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(parseInt(this.state.temptotal_audience_email_pre) + parseInt(this.state.tempaddress_count))}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(parseInt(this.state.tempnon_preclub_emails) + parseInt(this.state.tempnon_eclub_emails))}</h2></GridItem>
                      </GridContainer>
                      
                      <GridContainer style={{paddingBottom:"12px"}}>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", paddingLeft: "20px", float:"left", color:"#417a94"}}>Preclub Emails</h2> </GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(parseInt(this.state.temptotal_audience_email_pre))}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}> {this.numberWithCommas(parseInt(this.state.tempnon_preclub_emails))}</h2></GridItem>
                      </GridContainer>
                      
                      <GridContainer>
                          <GridItem xs={12} sm={12} md={6}><h2 style={{textAlign:"left", paddingLeft: "20px", float:"left", color:"#417a94"}}>Eclub Emails</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(parseInt(this.state.tempaddress_count))}</h2></GridItem>
                          <GridItem xs={12} sm={12} md={3}><h2 style={{textAlign:"right", float:"right", color:"#417a94"}}>{this.numberWithCommas(parseInt(this.state.tempnon_eclub_emails))}</h2></GridItem>
                      </GridContainer>*/}
                              </CardBody>
                            )}
                          {(
                            this.decryptLocal("activeChannel") === "d1606aea-0c0d-4fba-83e8-a124f414a953" ||
                            this.decryptLocal("activeChannel") === "a8f39ffb-24c5-432a-9bcd-e5d0166a320e"
                          ) && (
                              <CardBody
                                style={{
                                  //height: "375px",
                                  textAlign: "center",
                                  marginBottom: "0px",
                                }}
                              >
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "left",
                                        float: "left",
                                        color: "#417a94",
                                      }}
                                    >
                                      Total Customers
                                    </h2>{" "}
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "right",
                                        float: "right",
                                        color: "#417a94",
                                        paddingRight: "35px",
                                      }}
                                    >
                                      {this.numberWithCommas(
                                        "total_customers" in
                                          this.props.filter_result_json
                                          ? this.props.filter_result_json[
                                          "total_customers"
                                          ]["total"]
                                          : 0
                                      )}
                                    </h2>
                                  </GridItem>
                                </GridContainer>
                                {/* <Select
                                value={
                                  this.state.channelsDropDown.filter(
                                    (o) =>
                                      o.value ===
                                      this.decryptLocal("activeChannel")
                                  )[0]
                                }
                                onChange={this.handleChannelDropDownChange}
                                options={this.state.channelsDropDown}
                              /> */}
                                <hr />

                                <GridContainer style={{ paddingBottom: "10px" }}>
                                  <GridItem xs={12} sm={12} md={6}>
                                    <h2
                                      style={{
                                        textAlign: "left",
                                        float: "left",
                                        color: "#417a94",
                                      }}
                                    >
                                      Customers
                                    </h2>
                                  </GridItem>
                                </GridContainer>
                                <GridContainer>
                                  <GridContainer
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          paddingLeft: "50px",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Control Group
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "50px",
                                        }}
                                      >
                                        {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                        {this.numberWithCommas(
                                          "customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "customers"
                                            ]["control"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  <GridContainer
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          paddingLeft: "50px",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Marketable
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "50px",
                                        }}
                                      >
                                        {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                        {this.numberWithCommas(
                                          "customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "customers"
                                            ]["marketable"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                  <GridContainer
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "left",
                                          paddingLeft: "50px",
                                          float: "left",
                                          color: "#417a94",
                                        }}
                                      >
                                        Total
                                      </h2>{" "}
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={6}>
                                      <h2
                                        style={{
                                          textAlign: "right",
                                          float: "right",
                                          color: "#417a94",
                                          paddingRight: "50px",
                                        }}
                                      >
                                        {/* {this.numberWithCommas(this.props.filter_result_json[subs][sub1])} */}
                                        {this.numberWithCommas(
                                          "customers" in
                                            this.props.filter_result_json
                                            ? this.props.filter_result_json[
                                            "customers"
                                            ]["total"]
                                            : 0
                                        )}
                                      </h2>
                                    </GridItem>
                                  </GridContainer>
                                </GridContainer>
                              </CardBody>
                            )}
                        </LoadingOverlay>
                      </div>
                    )}
                  </Card>
                )}
              </GridItem>
            </GridContainer>
            <GridContainer>
              {/*<GridItem xs={4} sm={4} md={4} xl={4}>
              <Card>
                <div className="filtercentercontent summarycontent">
                  <div className="filteraudiencetitle summarytitle">
                    <h2 className="capitalize">Control/Hold Out</h2>
                  </div>
                  <CardBody style={{width: "100%", display: 'block', justifyContent: "center"}}>
                    <div style={{paddingTop: "20px"}}>
                    <Slider
                        classes={{ container: classes.slider }}
                        value={this.props.sliderValue['sliderValue']}
                        aria-labelledby="label"
                        step={1}
                        onChange={this.handleSliderChange}
                      />
                      <br/>
                      <h2> {this.props.sliderValue['sliderValue']} % or <strong>{this.numberWithCommas(this.props.sliderValue['excludedCount'])}</strong></h2>
                      <br/>
                      <p>audience members will be excluded</p>
                    </div>
                  </CardBody>
                </div>
              </Card>
            </GridItem>*/}
              {/* commenting preview <GridItem xs={12} sm={12} md={12} xl={12}>
              <Card>
                <div className="filtercentercontent summarycontent">
                  <div
                    className="filteraudiencetitle summarytitle"
                    style={{ minHeight: "40px" }}
                  >
                    <h2 className="capitalize">Preview</h2>
                  </div>
                  <CardBody
                    style={{
                      textAlign: "left",
                      overflow: "auto",
                      height: "350px"
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center"
                      }}
                    >
                      {showTable}
                    </div>
                  </CardBody>
                </div>
              </Card>
                    </GridItem> */}
            </GridContainer>
          </div>
        ) : this.state.isCustomerClicked === true ? (
          <CustomerFilter />
        ) : (
          " "
        );
      // ) : this.state.isCustomerClicked === true ?( <CustomerFilter/> ) : " " ;
    } else if (this.state.activeTab === "Summary") {
      content =
        this.state.isAcquistionClicked === true ? (
          <div>
            <GridContainer
              style={{
                display: "inline-block",
                width: "35vw",
                paddingBottom: "60px !important",
              }}
            >
              <GridItem
                xs={12}
                sm={12}
                md={12}
                xl={12}
                style={{ height: "50vh" }}
              >
                <Card>
                  <div className="filtercentercontent summarycontent">
                    <div className="filteraudiencetitle summarytitle">
                      <h2 className="capitalize">Properties</h2>
                    </div>
                    <CardBody style={{ height: "35vh" }}>
                      <div style={{ paddingTop: "20px" }}>
                        <CustomInput
                          labelText="Title"
                          id="groupTitle"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            onChange: (event) =>
                              this.handleChangeInput(event, "groupTitle"),
                            value: this.state.groupTitle,
                          }}
                        />
                        <span className="redColor">
                          {this.state.errors["groupTitle"]}
                        </span>
                        <br />
                        <CustomInput
                          labelText="Description"
                          id="listDescription"
                          formControlProps={{
                            fullWidth: true,
                          }}
                          inputProps={{
                            onChange: (event) =>
                              this.handleChangeInput(event, "listDescription"),
                            value: this.state.listDescription,
                          }}
                        />
                        <span className="redColor">
                          {this.state.errors["listDescription"]}
                        </span>
                      </div>
                    </CardBody>
                  </div>
                </Card>
              </GridItem>
            </GridContainer>

            <Summary editMode={this.props.id} />
          </div>
        ) : // </CardBody>
          // {/* <CardFooter /> */}
          // </Card>
          this.state.isCustomerClicked === true ? (
            <CustomerAudience
              {...this.props}
              errors={this.state.errors}
              handleChangeInput={this.handleChangeInput}
              groupTitle={this.state.groupTitle}
              listDescription={this.state.listDescription}
            />
          ) : (
            " "
          );
    } else if (this.state.activeTab === "CustSource") {
      content =
        this.state.isAcquistionClicked === true ? (
          <AcqCustSource />
        ) : this.state.isCustomerClicked === true ? (
          <CustSource />
        ) : (
          " "
        );
    } else {
      content =
        this.state.isAcquistionClicked === true ? (
          <CustSegment />
        ) : this.state.isCustomerClicked === true ? (
          <CustSegment />
        ) : (
          " "
        );
    }
    if (this.state.isAcquistionClicked == true) {
      let tabsData = (
        <React.Fragment>
          <li
            className={
              this.state.activeTab === "Filter"
                ? "righttopcontent-li-active-c"
                : "righttopcontent-li-c"
            }
          >
            <a
              onClick={() => this.handleclick("Filter")}
              className={
                this.state.activeTab === "Filter"
                  ? "summaryinfo-active-c"
                  : "summaryinfo-c"
              }
            >
              <center>
                <h2 className="capitalize">filters</h2>
                {/* <span>
                <i className="fa fa-check tick" aria-hidden="true" />
                
              </span> */}
                {/* <small>{showSpinner} audience members</small> */}
              </center>
            </a>
          </li>
          <li
            className={
              this.state.activeTab === "Segment"
                ? "righttopcontent-li-active-c"
                : "righttopcontent-li-c"
            }
          >
            <a
              onClick={() => this.handleclick("Segment")}
              className={
                this.state.activeTab === "Segment"
                  ? "summaryinfo-active-c"
                  : "summaryinfo-c"
              }
            >
              <center>
                <h2 className="capitalize">
                  {/* {this.state.customerType == "Acquistion"
                    ? this.props.segmentData.length
                    : this.props.cust_segmentData.length}{" "}
                  segments */}
                  segments
                </h2>
              </center>
              {/* <span>
                <i className="fa fa-check tick" aria-hidden="true" />
                segments
              </span> */}
            </a>
          </li>
        </React.Fragment>
      );
      partial = (
        <div className="dashboardMargin">
          <div
            className="audienceinfo-c"
            style={{ backgroundColor: "#eeeeee" }}
          >
            <div
              className="rightsidecontent-c"
              style={{ backgroundColor: "#eeeeee" }}
            >
              <ul className="righttopcontent-c">
                {/* <li
                  className={
                    this.state.activeTab === "CustSource"
                      ? "righttopcontent-li-active-c"
                      : "righttopcontent-li-c"
                  }
                >
                  <a
                    onClick={() => this.handleclick("CustSource")}
                    className={
                      this.state.activeTab === "CustSource"
                        ? "summaryinfo-active-c"
                        : "summaryinfo-c"
                    }
                  >
                    <center>
                      <h2 className="capitalize">Acquistion Source</h2>
                    </center>
                  </a>
                </li> */}
                {tabsData}
                <li
                  className={
                    this.state.activeTab === "Summary"
                      ? "righttopcontent-li-active-c"
                      : "righttopcontent-li-c"
                  }
                >
                  <a
                    onClick={() => this.handleclick("Summary")}
                    className={
                      this.state.activeTab === "Summary"
                        ? "summaryinfo-active-c"
                        : "summaryinfo-c"
                    }
                  >
                    <center>
                      <h2 className="capitalize">summary</h2>
                      {/* <span>
                      <i className="fa fa-check tick" aria-hidden="true" />{" "}
                      
                    </span> */}
                      {this.state.lastModifiedDate != "" ? (
                        <small>
                          last saved on {this.state.lastModifiedDate}
                        </small>
                      ) : (
                        ""
                      )}
                    </center>
                  </a>
                </li>
                <div
                  style={{
                    display: "inline-block",
                    justifyContent: "center",
                    float: "right",
                  }}
                >
                  <Button
                    className="btn btncreate"
                    // className="buttonRight"
                    color="secondary"
                    onClick={(e) => this.submitQuery(e, false)}
                    style={{ marginRight: "4px" }}
                  >
                    Save
                  </Button>
                  <Button
                    className="btn btncreate"
                    //className="buttonRight"
                    color="secondary"
                    onClick={() => this.setState({ redirect: true })}
                    style={{ marginRight: "4px" }}
                  >
                    Cancel
                  </Button>
                </div>
                <div style={{ display: "inline-block", float: "right" }}>
                  <Button
                    className="btn btncreate"
                    // className="buttonRight"
                    color="secondary"
                    onClick={(e) => this.submitQuery(e, true)}
                    style={{ marginRight: "4px" }}
                  >
                    Save and close
                  </Button>
                </div>
              </ul>
              <div className="filtercentercontent summarycontent">
                <div
                  className="filteraudiencetitle summarytitle"
                  style={{
                    width: "30%",
                    marginTop: "10px",
                    minHeight: "40px",
                    background: "#A9A9A9",
                    borderRadius: "0px",
                  }}
                >
                  <h5 className="capitalize" style={{ color: "white" }}>
                    Audience : Prospect {">"} Channel :
                    {this.decryptLocal("activeChannel") === "d977fc2b-2352-473b-9a54-b80765f0400c" ||
                      this.decryptLocal("activeChannel") === "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91"
                      ? " Email"
                      : this.decryptLocal("activeChannel") === "2c77a7b6-60e9-4c75-819e-e93b60d47b82" ? " Direct Mail" : " Display"}
                  </h5>
                </div>
              </div>
              <div className="filtercentercontent">{content}</div>
            </div>
          </div>{" "}
        </div>
      );
    } else if (this.state.showEclub) {
      // partial = (
      // <div className={this.state.showEclub ? "block" : "hidden"}>
      // <NavPills
      // color="warning"
      // tabs={[
      // {
      // tabButton: "Geography",
      // tabContent: (
      // <Geography
      // initValueJSON={this.state.geographyInitValueJSON}
      // />
      // )
      // },
      // {
      // tabButton: "Segments",
      // tabContent: (
      // <Segments initValueJSON={this.state.segmentsInitValueJSON} />
      // )
      // },
      // {
      // tabButton: "Demographics",
      // tabContent: (
      // <Demographics
      // initValueJSON={this.state.demographicsInitValueJSON}
      // />
      // )
      // },
      // {
      // tabButton: "Behaviors",
      // tabContent: (
      // <Behaviors
      // initValueJSON={this.state.demographicsInitValueJSON}
      // />
      // )
      // },
      // {
      // tabButton: "Menu Options",
      // tabContent: (
      // <MenuOptions
      // initValueJSON={this.state.demographicsInitValueJSON}
      // />
      // )
      // }
      // ]}
      // />
      // </div>2
      // );
    } else if (this.state.isCustomerClicked == true) {
      partial = (
        <CustomerTabs
          {...this.props}
          {...this.state}
          customerSegmentData={this.props.cust_segmentData}
          content={content}
          activeTab={this.state.activeTab}
          handleclick={this.handleclick}
          submitQuery={this.submitQuery}
          showSpinner={showSpinner}
          showChartSpinner={showChartSpinner}
        />
      );
      //
    }
    return this.state.isLoading === false ? (
      <div className="dashboardMargin">
        <Tabs
          selectedIndex={this.state.defaultIndex}
          async
          onSelect={(index) => {
            this.setState({ changeTab: false });
            this.state.tabIndex = index;
            this.handleClickOpen("changeModal");
          }}
        >
          {/*<TabList>
            <Tab>Acquistion</Tab>
            <Tab>Eclub</Tab>
            <Tab>Customer Connect</Tab>
            </TabList>
            <TabPanel></TabPanel>
            <TabPanel></TabPanel>
            <TabPanel></TabPanel>
          */}
        </Tabs>
        {/* <GridContainer>
          <Card>
            <CardBody> */}

        {partial}
        <div className={classes.container}>
          {this.state.alert}
          <GridItem xs={12} sm={12} md={12} xl={12}>
            <Snackbar
              place="tr"
              color={this.state.color}
              message={this.state.message}
              open={this.state.tr}
              closeNotification={() => this.setState({ tr: false })}
              close
            />
            <Snackbar
              place="td"
              color="warning"
              message={this.state.message}
              open={this.state.td}
              closeNotification={() => this.setState({ td: false })}
              close
            />
          </GridItem>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.classicModal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("classicModal")}
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{
                textAlign: "left",
                backgroundColor: "#69ff45",
                paddingBottom: "15px",
              }}
            >
              {/* <Button
 justIcon
 className={classes.modalCloseButton}
 key="close"
 aria-label="Close"
 color="transparent"
 onClick={() => this.handleClose("classicModal")}
 >
 <Close className={classes.modalClose} />
 </Button> */}
              <h4
                className={classes.modalTitle}
                style={{
                  color: "#69ff45",
                  //color: "#f5f5f5"
                }}
              >
                CREATE AUDIENCE
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
              style={{
                backgroundColor: "#D3D3D3",
              }}
            />
            <DialogActions
              className={classes.modalFooter}
              style={{
                backgroundColor: "#D3D3D3",
              }}
            >
              <Button
                onClick={() => this.handleClose("classicModal")}
                color="danger"
                simple
              >
                Cancel
              </Button>
              <Button color="transparent">Apply</Button>
            </DialogActions>
          </Dialog>
          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.typeModal}
            //onClose={() => this.handleClose("typeModal")}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
            >
              <h4 className={classes.modalTitle}>
                <strong>Choose Audience Type</strong>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              {(this.state.localStorageClientId ===
                "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
                this.state.localStorageClientId ===
                "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
                this.state.localStorageClientId ===
                "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                this.state.localStorageClientId ===
                "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
                this.state.localStorageClientId ===
                "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
                this.state.localStorageClientId ===
                "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
                this.state.localStorageClientId ===
                "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
                this.state.localStorageClientId ===
                "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
                this.state.localStorageClientId ===
                "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
                this.state.localStorageClientId ===
                "7abec586-17b8-4174-993d-e3d86648ed60" ||
                this.state.localStorageClientId ===
                "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
                this.state.localStorageClientId ===
                "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
                this.state.localStorageClientId ===
                "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
                this.state.localStorageClientId ===
                "712cc8e9-3a79-4900-b122-ec9812e0f0ca" ||
                this.state.localStorageClientId ===
                "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
                this.state.localStorageClientId ===
                "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
                this.state.localStorageClientId ===
                "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
                this.state.localStorageClientId ===
                "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
                this.state.localStorageClientId ===
                "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
                this.state.localStorageClientId ===
                "7203dd51-f88b-4a4b-877c-92326d027915" ||
                this.state.localStorageClientId ===
                "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
                this.state.localStorageClientId === 
                "874b6c6a-83ff-480b-b615-1972538813ba" ||
                this.state.localStorageClientId === 
                "b76e7818-deb1-4526-93a7-b398df3ea357" ||
                this.state.localStorageClientId === 
                "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
                this.state.localStorageClientId === 
                  "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
                this.state.localStorageClientId === 
                  "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
                this.state.localStorageClientId === 
                  "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
                this.state.localStorageClientId === 
                  "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
                this.state.localStorageClientId === 
                  "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
                this.state.localStorageClientId === 
                  "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
                this.state.localStorageClientId ===
                  "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
                this.state.localStorageClientId ===
                  "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
                this.state.localStorageClientId ===
                  "24ab940a-50d2-41fd-b3b2-c67ca6cb0304" ) && (
                  <React.Fragment>
                    <section>
                      <Button
                        color="secondary"
                        className="btn btncreate"
                        style={{
                          width: "100%",
                          display: "table-cell",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                        onClick={() => this.setChannelToCustType("Acquistion")}
                      >
                        Prospect
                      </Button>
                    </section>
                    <br />
                  </React.Fragment>
                )}
              <section>
                <Button
                  color="secondary"
                  className="btn btncreate"
                  style={{
                    width: "100%",
                    display: "table-cell",
                    verticalAlign: "middle",
                    textAlign: "center",
                  }}
                  onClick={() => this.setChannelToCustType("Customer")}
                >
                  Customer
                </Button>
              </section>
            </DialogContent>
          </Dialog>

          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.channelModal}
            //onClose={() => this.handleClose("typeModal")}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
            >
              <h4 className={classes.modalTitle}>
                <strong>Choose Channel</strong>
              </h4>
            </DialogTitle>
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              {this.decryptLocal("channelsAllObj").map(
                (stif, idx) =>
                  stif.display == true ? (
                    <section>
                      <Button
                        color="secondary"
                        className="btn btncreate"
                        style={{
                          width: "100%",
                          display: "table-cell",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                        onClick={() => this.setCustType(stif.id)}
                      >
                        {stif.program}
                      </Button>
                    </section>
                  ) : (
                    <section>
                      <Button
                        color="secondary"
                        className="btn btncreate"
                        style={{
                          width: "100%",
                          display: "table-cell",
                          verticalAlign: "middle",
                          textAlign: "center",
                        }}
                        onClick={() => this.setCustType("Acquistion")}
                        disabled
                      >
                        {stif.program}
                      </Button>
                    </section>
                  )
              )}
            </DialogContent>
          </Dialog>

          <Dialog
            classes={{
              root: classes.center + " " + classes.modalRoot,
              paper: classes.modal,
            }}
            open={this.state.changeModal}
            //onClose={() => this.handleClose("typeModal")}
            TransitionComponent={Transition}
            keepMounted
            aria-labelledby="classic-modal-slide-title"
            aria-describedby="classic-modal-slide-description"
          >
            <DialogContent
              id="classic-modal-slide-description"
              className={classes.modalBody}
            >
              <h4 className={classes.modalTitle}>
                Leaving this page will discard any changes you may have not
                saved Continue and discard changes?
              </h4>
            </DialogContent>
            <DialogActions className={classes.modalFooter}>
              <Button
                color="success"
                onClick={() => {
                  this.setState({ changeTab: true });
                  //$("#immuTreeGeography").text("test");
                  this.setState({
                    demographicsInitValueJSON:
                      '["~#iM",["type","group","id","9a99988a-0123-4456-b89a-b1607f326fd8","children1",["~#iOM",["a98ab9b9-cdef-4012-b456-71607f326fd9",["^0",["type","rule","id","a98ab9b9-cdef-4012-b456-71607f326fd9","properties",["^0",["field","num","operator","less","value",["~#iL",[2]],"valueSrc",["^2",["value"]],"operatorOptions",null,"valueType",["^2",["number"]]]]]]]],"properties",["^0",["conjunction","AND","not",false]]]]',
                  });
                  this.setState({
                    geographyInitValueJSON:
                      '["~#iM",["type","group","id","9a99988a-0123-4456-b89a-b1607f326fd8","children1",["~#iOM",["a98ab9b9-cdef-4012-b456-71607f326fd9",["^0",["type","rule","id","a98ab9b9-cdef-4012-b456-71607f326fd9","properties",["^0",["field","num","operator","less","value",["~#iL",[2]],"valueSrc",["^2",["value"]],"operatorOptions",null,"valueType",["^2",["number"]]]]]]]],"properties",["^0",["conjunction","AND","not",false]]]]',
                  });
                  this.setState({
                    segmentsInitValueJSON:
                      '["~#iM",["type","group","id","9a99988a-0123-4456-b89a-b1607f326fd8","children1",["~#iOM",["a98ab9b9-cdef-4012-b456-71607f326fd9",["^0",["type","rule","id","a98ab9b9-cdef-4012-b456-71607f326fd9","properties",["^0",["field","num","operator","less","value",["~#iL",[2]],"valueSrc",["^2",["value"]],"operatorOptions",null,"valueType",["^2",["number"]]]]]]]],"properties",["^0",["conjunction","AND","not",false]]]]',
                  });

                  this.setState({
                    defaultIndex: this.state.tabIndex,
                  });
                  if (this.state.tabIndex == 1) {
                    this.setState({
                      showAcquistion: false,
                      showEclub: true,
                      showCustomerConnect: false,
                      customerType: "Eclub",
                    });
                  } else if (this.state.tabIndex == 2) {
                    this.setState({
                      showAcquistion: false,
                      showEclub: false,
                      showCustomerConnect: true,
                      customerType: "Customer",
                    });
                  } else {
                    this.setState({
                      showAcquistion: true,
                      showEclub: false,
                      showCustomerConnect: false,
                      customerType: "Acquistion",
                    });
                  }
                  this.handleClose("changeModal");
                }}
              >
                Yes
              </Button>
              <Button
                color="danger"
                onClick={() => this.handleClose("changeModal")}
                simple
              >
                No
              </Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* </CardBody>
          </Card>
        </GridContainer> */}
      </div>
    ) : (
      <center>
        <GridContainer
          style={{
            width: "100%",
            display: "flex",
            height: "100vh",
            justifyContent: "center",
          }}
        >
          <div style={{ alignSelf: "center" }}>
            <i className="fa fa-spinner fa-spin" style={{ fontSize: "50px" }} />
          </div>
        </GridContainer>
      </center>
    );
  }
}
const mapStateToProps = (state) => ({
  count: state.count,
  tillSqlSelectionArr: state.tillSqlSelectionArr,
  afterSqlSelectionArr: state.afterSqlSelectionArr,
  ruleLeveltoggle: state.ruleLeveltoggle,
  groupLeveltoggle: state.groupLeveltoggle,
  title: state.title,
  listDescription: state.listDescription,
  queryCount: state.queryCount,
  showQuerySpinner: state.showQuerySpinner,
  previewData: state.previewData,

  countSegment: state.countSegment,
  tillSqlSelectionArrSegment: state.tillSqlSelectionArrSegment,
  afterSqlSelectionArrSegment: state.afterSqlSelectionArrSegment,
  ruleLeveltoggleSegment: state.ruleLeveltoggleSegment,
  groupLeveltoggleSegment: state.groupLeveltoggleSegment,

  queryCountSegment: state.queryCountSegment,
  showQuerySpinnerSegment: state.showQuerySpinnerSegment,
  previewDataSegment: state.previewDataSegment,
  segmentName: state.segmentName,
  segmentData: state.segmentData,
  hideTabs: state.hideTabs,
  sliderValue: state.sliderValue,
  queryCountTempSegment: state.queryCountTempSegment,

  ///
  cust_count: state.cust_count,
  cust_tillSqlSelectionArr: state.cust_tillSqlSelectionArr,
  cust_afterSqlSelectionArr: state.cust_afterSqlSelectionArr,
  cust_ruleLeveltoggle: state.cust_ruleLeveltoggle,
  cust_groupLeveltoggle: state.cust_groupLeveltoggle,

  cust_title: state.cust_title,
  cust_listDescription: state.cust_listDescription,
  cust_queryCount: state.cust_queryCount,
  cust_showQuerySpinner: state.cust_showQuerySpinner,
  cust_previewData: state.cust_previewData,

  cust_countSegment: state.cust_countSegment,
  cust_tillSqlSelectionArrSegment: state.cust_tillSqlSelectionArrSegment,
  cust_afterSqlSelectionArrSegment: state.cust_afterSqlSelectionArrSegment,
  cust_ruleLeveltoggleSegment: state.cust_ruleLeveltoggleSegment,
  cust_groupLeveltoggleSegment: state.cust_groupLeveltoggleSegment,

  cust_queryCountSegment: state.cust_queryCountSegment,
  cust_showQuerySpinnerSegment: state.cust_showQuerySpinnerSegment,
  cust_previewDataSegment: state.cust_previewDataSegment,
  cust_segmentName: state.cust_segmentName,
  cust_segmentData: state.cust_segmentData,
  cust_hideTabs: state.cust_hideTabs,
  cust_sliderValue: state.cust_sliderValue,
  cust_queryCountTempSegment: state.cust_queryCountTempSegment,
  filter_result_json: state.filter_result_json,
  filter_result_json_prospects: state.filter_result_json_prospects,
  overlaySpinner: state.overlaySpinner,
});

export default connect(mapStateToProps)(
  withStyles(notificationsStyle)(CreateAudiences)
);



// WEBPACK FOOTER //
// ./src/views/Audiences/CreateAudiences.jsx